/*! For license information please see index.js.LICENSE.txt */
(() => {
  var t = {
      412: (t, e) => {
        (() => {
          'use strict';
          var t = {
              d: (e, r) => {
                for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: r[n] });
              },
              o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
              r: (t) => {
                'undefined' != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
                  Object.defineProperty(t, '__esModule', { value: !0 });
              },
            },
            r = {};
          function n(t) {
            return (
              (n =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              n(t)
            );
          }
          function o() {
            o = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              i = r.hasOwnProperty,
              a =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              c = 'function' == typeof Symbol ? Symbol : {},
              u = c.iterator || '@@iterator',
              s = c.asyncIterator || '@@asyncIterator',
              l = c.toStringTag || '@@toStringTag';
            function d(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              d({}, '');
            } catch (t) {
              d = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function f(t, e, r, n) {
              var o = e && e.prototype instanceof b ? e : b,
                i = Object.create(o.prototype),
                c = new T(n || []);
              return a(i, '_invoke', { value: A(t, r, c) }), i;
            }
            function h(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = f;
            var p = 'suspendedStart',
              v = 'suspendedYield',
              y = 'executing',
              m = 'completed',
              g = {};
            function b() {}
            function w() {}
            function x() {}
            var E = {};
            d(E, u, function () {
              return this;
            });
            var L = Object.getPrototypeOf,
              O = L && L(L(C([])));
            O && O !== r && i.call(O, u) && (E = O);
            var S = (x.prototype = b.prototype = Object.create(E));
            function _(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                d(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function P(t, e) {
              function r(o, a, c, u) {
                var s = h(t[o], t, a);
                if ('throw' !== s.type) {
                  var l = s.arg,
                    d = l.value;
                  return d && 'object' == n(d) && i.call(d, '__await')
                    ? e.resolve(d.__await).then(
                        function (t) {
                          r('next', t, c, u);
                        },
                        function (t) {
                          r('throw', t, c, u);
                        },
                      )
                    : e.resolve(d).then(
                        function (t) {
                          (l.value = t), c(l);
                        },
                        function (t) {
                          return r('throw', t, c, u);
                        },
                      );
                }
                u(s.arg);
              }
              var o;
              a(this, '_invoke', {
                value: function (t, n) {
                  function i() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (o = o ? o.then(i, i) : i());
                },
              });
            }
            function A(e, r, n) {
              var o = p;
              return function (i, a) {
                if (o === y) throw new Error('Generator is already running');
                if (o === m) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = k(c, n);
                    if (u) {
                      if (u === g) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === p) throw ((o = m), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = y;
                  var s = h(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? m : v), s.arg === g)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = m), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function k(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), k(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  g
                );
              var i = h(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), g;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    g)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  g);
            }
            function I(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function j(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function T(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(I, this), this.reset(!0);
            }
            function C(e) {
              if (e || '' === e) {
                var r = e[u];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    a = function r() {
                      for (; ++o < e.length; ) if (i.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (a.next = a);
                }
              }
              throw new TypeError(n(e) + ' is not iterable');
            }
            return (
              (w.prototype = x),
              a(S, 'constructor', { value: x, configurable: !0 }),
              a(x, 'constructor', { value: w, configurable: !0 }),
              (w.displayName = d(x, l, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === w || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, x)
                    : ((t.__proto__ = x), d(t, l, 'GeneratorFunction')),
                  (t.prototype = Object.create(S)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              _(P.prototype),
              d(P.prototype, s, function () {
                return this;
              }),
              (e.AsyncIterator = P),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new P(f(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              _(S),
              d(S, l, 'Generator'),
              d(S, u, function () {
                return this;
              }),
              d(S, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = C),
              (T.prototype = {
                constructor: T,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(j),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && i.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function n(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                    var a = this.tryEntries[o],
                      c = a.completion;
                    if ('root' === a.tryLoc) return n('end');
                    if (a.tryLoc <= this.prev) {
                      var u = i.call(a, 'catchLoc'),
                        s = i.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return n(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return n(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var n = this.tryEntries[r];
                    if (n.tryLoc <= this.prev && i.call(n, 'finallyLoc') && this.prev < n.finallyLoc) {
                      var o = n;
                      break;
                    }
                  }
                  o && ('break' === t || 'continue' === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
                  var a = o ? o.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    o ? ((this.method = 'next'), (this.next = o.finallyLoc), g) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    g
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), g;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        j(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: C(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    g
                  );
                },
              }),
              e
            );
          }
          function i(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function a(t) {
            return function () {
              var e = this,
                r = arguments;
              return new Promise(function (n, o) {
                var a = t.apply(e, r);
                function c(t) {
                  i(a, n, o, c, u, 'next', t);
                }
                function u(t) {
                  i(a, n, o, c, u, 'throw', t);
                }
                c(void 0);
              });
            };
          }
          t.r(r),
            t.d(r, {
              CURRENT_POSITION: () => O,
              DEFAULT_POSITION: () => E,
              USER_POSITION: () => L,
              USER_POSITION_CONSENT: () => x,
              USER_STORAGE_CONSENT: () => w,
              _defaultPosition: () => J,
              api: () => u,
              createAutocompleteHandler: () => v,
              createDebounceFn: () => C,
              createExpirationValue: () => T,
              createPosition: () => z,
              createThrottleFn: () => D,
              delay: () => I,
              fetchProductAvailabilities: () => mt,
              fetchUserDefaultPosition: () => W,
              fetchUserPosition: () => q,
              findNearestStore: () => _t,
              from12to24Hours: () => G,
              from24to12Hours: () => N,
              getDevice: () => m,
              getDistanceText: () => St,
              getExpirable: () => b,
              getRadialDistanceFn: () => et,
              getStoreOpeningTime: () => R,
              isInViewport: () => Pt,
              isPositionInBounds: () => rt,
              positionToLatLngLiteral: () => nt,
              positionToLatLngPair: () => ot,
              report: () => M,
              retailTuneAutocompleteHandler: () => y,
              sendIsochronePolygonalEvents: () => lt,
              sendProximityEvents: () => st,
              setExpirable: () => g,
              sortStoresByDistance: () => Lt,
              sortStoresByPriority: () => Ot,
              updateWidgetState: () => gt,
            });
          var c = { development: 'test.api.retailtune.com', production: 'api.retailtune.com' },
            u = {
              origin: 'https://' + c.development,
              setOrigin: function (t) {
                switch (t.type) {
                  case 'production':
                  case 'development':
                    this.origin = 'https://' + c[t.type];
                    break;
                  case 'custom':
                    this.origin = 'https://' + t.hostname;
                }
              },
              fetchHostnames: function (t) {
                var e = this;
                return a(
                  o().mark(function r() {
                    var n, i, a;
                    return o().wrap(function (r) {
                      for (;;)
                        switch ((r.prev = r.next)) {
                          case 0:
                            return (
                              (r.next = 2), fetch(''.concat(e.origin, '/v1/validate-hostname?rt_api_key=').concat(t))
                            );
                          case 2:
                            if ((n = r.sent).ok) {
                              r.next = 5;
                              break;
                            }
                            throw new Error('Fetch failed: HTTP status '.concat(n.status));
                          case 5:
                            return (r.next = 7), n.json();
                          case 7:
                            for (a in (i = r.sent)) i[a] = 'https://'.concat(i[a]);
                            return r.abrupt('return', i);
                          case 10:
                          case 'end':
                            return r.stop();
                        }
                    }, r);
                  }),
                )();
              },
              fetchPageData: function (t, e) {
                var r = this;
                return a(
                  o().mark(function n() {
                    var i;
                    return o().wrap(function (n) {
                      for (;;)
                        switch ((n.prev = n.next)) {
                          case 0:
                            return (
                              (n.next = 2),
                              fetch(''.concat(r.origin, '/storelocator/').concat(e, '/?rt_api_key=').concat(t))
                            );
                          case 2:
                            if ((i = n.sent).ok) {
                              n.next = 5;
                              break;
                            }
                            throw new Error('Fetch failed: HTTP status '.concat(i.status));
                          case 5:
                            return n.abrupt('return', i.json());
                          case 6:
                          case 'end':
                            return n.stop();
                        }
                    }, n);
                  }),
                )();
              },
              defaultPositionGetURL: function () {
                return ''.concat(this.origin, '/v1/default-positions/get');
              },
              geocodeURL: function () {
                return ''.concat(this.origin, '/geocode');
              },
              intersectingIsochronesGetURL: function () {
                return ''.concat(this.origin, '/v1/intersecting-isochrones/get');
              },
              productAvailabilityInStoresURL: function () {
                return ''.concat(this.origin, '/api/v1/estore/is-product-available-in-stores');
              },
            };
          function s(t) {
            return (
              (s =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              s(t)
            );
          }
          function l(t, e) {
            var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
            if (!r) {
              if (
                Array.isArray(t) ||
                (r = (function (t, e) {
                  if (t) {
                    if ('string' == typeof t) return d(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return (
                      'Object' === r && t.constructor && (r = t.constructor.name),
                      'Map' === r || 'Set' === r
                        ? Array.from(t)
                        : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                        ? d(t, e)
                        : void 0
                    );
                  }
                })(t)) ||
                (e && t && 'number' == typeof t.length)
              ) {
                r && (t = r);
                var n = 0,
                  o = function () {};
                return {
                  s: o,
                  n: function () {
                    return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
                  },
                  e: function (t) {
                    throw t;
                  },
                  f: o,
                };
              }
              throw new TypeError(
                'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
              );
            }
            var i,
              a = !0,
              c = !1;
            return {
              s: function () {
                r = r.call(t);
              },
              n: function () {
                var t = r.next();
                return (a = t.done), t;
              },
              e: function (t) {
                (c = !0), (i = t);
              },
              f: function () {
                try {
                  a || null == r.return || r.return();
                } finally {
                  if (c) throw i;
                }
              },
            };
          }
          function d(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
          }
          function f() {
            f = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              n = r.hasOwnProperty,
              o =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              i = 'function' == typeof Symbol ? Symbol : {},
              a = i.iterator || '@@iterator',
              c = i.asyncIterator || '@@asyncIterator',
              u = i.toStringTag || '@@toStringTag';
            function l(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              l({}, '');
            } catch (t) {
              l = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function d(t, e, r, n) {
              var i = e && e.prototype instanceof b ? e : b,
                a = Object.create(i.prototype),
                c = new T(n || []);
              return o(a, '_invoke', { value: A(t, r, c) }), a;
            }
            function h(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = d;
            var p = 'suspendedStart',
              v = 'suspendedYield',
              y = 'executing',
              m = 'completed',
              g = {};
            function b() {}
            function w() {}
            function x() {}
            var E = {};
            l(E, a, function () {
              return this;
            });
            var L = Object.getPrototypeOf,
              O = L && L(L(C([])));
            O && O !== r && n.call(O, a) && (E = O);
            var S = (x.prototype = b.prototype = Object.create(E));
            function _(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                l(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function P(t, e) {
              function r(o, i, a, c) {
                var u = h(t[o], t, i);
                if ('throw' !== u.type) {
                  var l = u.arg,
                    d = l.value;
                  return d && 'object' == s(d) && n.call(d, '__await')
                    ? e.resolve(d.__await).then(
                        function (t) {
                          r('next', t, a, c);
                        },
                        function (t) {
                          r('throw', t, a, c);
                        },
                      )
                    : e.resolve(d).then(
                        function (t) {
                          (l.value = t), a(l);
                        },
                        function (t) {
                          return r('throw', t, a, c);
                        },
                      );
                }
                c(u.arg);
              }
              var i;
              o(this, '_invoke', {
                value: function (t, n) {
                  function o() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (i = i ? i.then(o, o) : o());
                },
              });
            }
            function A(e, r, n) {
              var o = p;
              return function (i, a) {
                if (o === y) throw new Error('Generator is already running');
                if (o === m) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = k(c, n);
                    if (u) {
                      if (u === g) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === p) throw ((o = m), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = y;
                  var s = h(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? m : v), s.arg === g)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = m), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function k(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), k(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  g
                );
              var i = h(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), g;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    g)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  g);
            }
            function I(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function j(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function T(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(I, this), this.reset(!0);
            }
            function C(e) {
              if (e || '' === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (i.next = i);
                }
              }
              throw new TypeError(s(e) + ' is not iterable');
            }
            return (
              (w.prototype = x),
              o(S, 'constructor', { value: x, configurable: !0 }),
              o(x, 'constructor', { value: w, configurable: !0 }),
              (w.displayName = l(x, u, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === w || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, x)
                    : ((t.__proto__ = x), l(t, u, 'GeneratorFunction')),
                  (t.prototype = Object.create(S)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              _(P.prototype),
              l(P.prototype, c, function () {
                return this;
              }),
              (e.AsyncIterator = P),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new P(d(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              _(S),
              l(S, u, 'Generator'),
              l(S, a, function () {
                return this;
              }),
              l(S, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = C),
              (T.prototype = {
                constructor: T,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(j),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function o(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                    var a = this.tryEntries[i],
                      c = a.completion;
                    if ('root' === a.tryLoc) return o('end');
                    if (a.tryLoc <= this.prev) {
                      var u = n.call(a, 'catchLoc'),
                        s = n.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                      var i = o;
                      break;
                    }
                  }
                  i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                  var a = i ? i.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    i ? ((this.method = 'next'), (this.next = i.finallyLoc), g) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    g
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), g;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        j(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: C(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    g
                  );
                },
              }),
              e
            );
          }
          function h(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function p(t) {
            return function () {
              var e = this,
                r = arguments;
              return new Promise(function (n, o) {
                var i = t.apply(e, r);
                function a(t) {
                  h(i, n, o, a, c, 'next', t);
                }
                function c(t) {
                  h(i, n, o, a, c, 'throw', t);
                }
                a(void 0);
              });
            };
          }
          function v() {
            for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
            return (function () {
              var t = p(
                f().mark(function t(r) {
                  var n, o, i, a;
                  return f().wrap(
                    function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            (n = 0), (o = e);
                          case 1:
                            if (!(n < o.length)) {
                              t.next = 21;
                              break;
                            }
                            return (i = o[n]), (t.prev = 3), (t.next = 6), i(r);
                          case 6:
                            if ('ok' !== (a = t.sent).type) {
                              t.next = 9;
                              break;
                            }
                            return t.abrupt('return', a.data);
                          case 9:
                            if ('error' !== a.type) {
                              t.next = 11;
                              break;
                            }
                            return t.abrupt('continue', 18);
                          case 11:
                            return (
                              console.error('[AUTOCOMPLETE-ERROR]: prediction type is invalid'), t.abrupt('break', 21)
                            );
                          case 15:
                            (t.prev = 15),
                              (t.t0 = t.catch(3)),
                              console.error('[AUTOCOMPLETE-ERROR]: '.concat(JSON.stringify(t.t0)));
                          case 18:
                            n++, (t.next = 1);
                            break;
                          case 21:
                            return (
                              console.error('[AUTOCOMPLETE-ERROR]: no API was able to find a result'),
                              t.abrupt('return', [])
                            );
                          case 23:
                          case 'end':
                            return t.stop();
                        }
                    },
                    t,
                    null,
                    [[3, 15]],
                  );
                }),
              );
              return function (e) {
                return t.apply(this, arguments);
              };
            })();
          }
          function y(t, e) {
            var r = { type: 'autocomplete', text: '', lang: 'en', layers: ['street', 'locality', 'country'] };
            return (
              e &&
                (e.language && (r.lang = e.language),
                e.layers && (r.layers = e.layers),
                e.countries && (r.countries = e.countries),
                e.focalPoint &&
                  ((r.lat = e.focalPoint.latitude.toString()), (r.lon = e.focalPoint.longitude.toString()))),
              (function () {
                var e = p(
                  f().mark(function e(n) {
                    var o, i, a, c, s, d;
                    return f().wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (
                              (r.text = n),
                              (e.next = 3),
                              fetch(u.geocodeURL(), {
                                method: 'POST',
                                headers: { Accept: 'application/json', Authorization: 'Bearer '.concat(t) },
                                body: JSON.stringify(r),
                              })
                            );
                          case 3:
                            if (200 === (o = e.sent).status) {
                              e.next = 6;
                              break;
                            }
                            return e.abrupt('return', {
                              type: 'error',
                              message: 'Axios response status: '.concat(o.status),
                            });
                          case 6:
                            return (e.next = 8), o.json();
                          case 8:
                            if ('error' !== (i = e.sent).status) {
                              e.next = 11;
                              break;
                            }
                            return e.abrupt('return', {
                              type: 'error',
                              message: 'RT-API responded with status: '.concat(i.status),
                            });
                          case 11:
                            if ('ok' !== i.status) {
                              e.next = 16;
                              break;
                            }
                            (a = []), (c = l(i.items));
                            try {
                              for (c.s(); !(s = c.n()).done; )
                                (d = s.value),
                                  a.push({ description: d.item, latitude: +d.lat, longitude: +d.lon, layer: d.layer });
                            } catch (t) {
                              c.e(t);
                            } finally {
                              c.f();
                            }
                            return e.abrupt('return', { type: 'ok', data: a });
                          case 16:
                            return e.abrupt('return', { type: 'error', message: 'Unexpected RT-API response status' });
                          case 17:
                          case 'end':
                            return e.stop();
                        }
                    }, e);
                  }),
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            );
          }
          function m() {
            return window.innerWidth < 768 ? 'mobile' : window.innerWidth < 991 ? 'tablet' : 'desktop';
          }
          function g(t, e) {
            localStorage.setItem(t, JSON.stringify(e));
          }
          function b(t) {
            var e = localStorage.getItem(t);
            if (!e) return null;
            var r,
              n,
              o = JSON.parse(e);
            return (
              (r = o),
              Object.getOwnPropertyNames(r).includes('expiration')
                ? ((n = o),
                  new Date() > new Date(n.expiration) ? (localStorage.removeItem(t), null) : JSON.parse(o.value))
                : null
            );
          }
          var w = 'storage-usage-consent',
            x = 'user-position-usage-consent',
            E = 'default-position',
            L = 'user-position',
            O = 'current-position';
          function S(t) {
            return (
              (S =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              S(t)
            );
          }
          function _() {
            _ = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              n = r.hasOwnProperty,
              o =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              i = 'function' == typeof Symbol ? Symbol : {},
              a = i.iterator || '@@iterator',
              c = i.asyncIterator || '@@asyncIterator',
              u = i.toStringTag || '@@toStringTag';
            function s(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              s({}, '');
            } catch (t) {
              s = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function l(t, e, r, n) {
              var i = e && e.prototype instanceof m ? e : m,
                a = Object.create(i.prototype),
                c = new T(n || []);
              return o(a, '_invoke', { value: A(t, r, c) }), a;
            }
            function d(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = l;
            var f = 'suspendedStart',
              h = 'suspendedYield',
              p = 'executing',
              v = 'completed',
              y = {};
            function m() {}
            function g() {}
            function b() {}
            var w = {};
            s(w, a, function () {
              return this;
            });
            var x = Object.getPrototypeOf,
              E = x && x(x(C([])));
            E && E !== r && n.call(E, a) && (w = E);
            var L = (b.prototype = m.prototype = Object.create(w));
            function O(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                s(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function P(t, e) {
              function r(o, i, a, c) {
                var u = d(t[o], t, i);
                if ('throw' !== u.type) {
                  var s = u.arg,
                    l = s.value;
                  return l && 'object' == S(l) && n.call(l, '__await')
                    ? e.resolve(l.__await).then(
                        function (t) {
                          r('next', t, a, c);
                        },
                        function (t) {
                          r('throw', t, a, c);
                        },
                      )
                    : e.resolve(l).then(
                        function (t) {
                          (s.value = t), a(s);
                        },
                        function (t) {
                          return r('throw', t, a, c);
                        },
                      );
                }
                c(u.arg);
              }
              var i;
              o(this, '_invoke', {
                value: function (t, n) {
                  function o() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (i = i ? i.then(o, o) : o());
                },
              });
            }
            function A(e, r, n) {
              var o = f;
              return function (i, a) {
                if (o === p) throw new Error('Generator is already running');
                if (o === v) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = k(c, n);
                    if (u) {
                      if (u === y) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === f) throw ((o = v), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = p;
                  var s = d(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? v : h), s.arg === y)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function k(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), k(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  y
                );
              var i = d(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    y)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  y);
            }
            function I(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function j(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function T(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(I, this), this.reset(!0);
            }
            function C(e) {
              if (e || '' === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (i.next = i);
                }
              }
              throw new TypeError(S(e) + ' is not iterable');
            }
            return (
              (g.prototype = b),
              o(L, 'constructor', { value: b, configurable: !0 }),
              o(b, 'constructor', { value: g, configurable: !0 }),
              (g.displayName = s(b, u, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, b)
                    : ((t.__proto__ = b), s(t, u, 'GeneratorFunction')),
                  (t.prototype = Object.create(L)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              O(P.prototype),
              s(P.prototype, c, function () {
                return this;
              }),
              (e.AsyncIterator = P),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new P(l(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              O(L),
              s(L, u, 'Generator'),
              s(L, a, function () {
                return this;
              }),
              s(L, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = C),
              (T.prototype = {
                constructor: T,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(j),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function o(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                    var a = this.tryEntries[i],
                      c = a.completion;
                    if ('root' === a.tryLoc) return o('end');
                    if (a.tryLoc <= this.prev) {
                      var u = n.call(a, 'catchLoc'),
                        s = n.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                      var i = o;
                      break;
                    }
                  }
                  i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                  var a = i ? i.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    i ? ((this.method = 'next'), (this.next = i.finallyLoc), y) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    y
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), y;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        j(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: C(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    y
                  );
                },
              }),
              e
            );
          }
          function P(t, e) {
            return (
              (function (t) {
                if (Array.isArray(t)) return t;
              })(t) ||
              (function (t, e) {
                var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                if (null != r) {
                  var n,
                    o,
                    i,
                    a,
                    c = [],
                    u = !0,
                    s = !1;
                  try {
                    if (((i = (r = r.call(t)).next), 0 === e)) {
                      if (Object(r) !== r) return;
                      u = !1;
                    } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== e); u = !0);
                  } catch (t) {
                    (s = !0), (o = t);
                  } finally {
                    try {
                      if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
                    } finally {
                      if (s) throw o;
                    }
                  }
                  return c;
                }
              })(t, e) ||
              (function (t, e) {
                if (t) {
                  if ('string' == typeof t) return A(t, e);
                  var r = Object.prototype.toString.call(t).slice(8, -1);
                  return (
                    'Object' === r && t.constructor && (r = t.constructor.name),
                    'Map' === r || 'Set' === r
                      ? Array.from(t)
                      : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                      ? A(t, e)
                      : void 0
                  );
                }
              })(t, e) ||
              (function () {
                throw new TypeError(
                  'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                );
              })()
            );
          }
          function A(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
          }
          function k(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function I(t) {
            return j.apply(this, arguments);
          }
          function j() {
            var t;
            return (
              (t = _().mark(function t(e) {
                return _().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return t.abrupt(
                          'return',
                          new Promise(function (t) {
                            setTimeout(t, e);
                          }),
                        );
                      case 1:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              })),
              (j = function () {
                var e = this,
                  r = arguments;
                return new Promise(function (n, o) {
                  var i = t.apply(e, r);
                  function a(t) {
                    k(i, n, o, a, c, 'next', t);
                  }
                  function c(t) {
                    k(i, n, o, a, c, 'throw', t);
                  }
                  a(void 0);
                });
              }),
              j.apply(this, arguments)
            );
          }
          function T(t, e) {
            switch (e) {
              case 'minutes':
                return Date.now() + 60 * t * 1e3;
              case 'hours':
                return Date.now() + 60 * t * 1e3 * 60;
              case 'days':
                return Date.now() + 60 * t * 1e3 * 60 * 24;
              case 'months':
                return Date.now() + 60 * t * 1e3 * 60 * 24 * 30;
              case 'years':
                return Date.now() + 60 * t * 1e3 * 60 * 24 * 30 * 12;
              default:
                throw new Error('Expiration type "'.concat(e, '" is not valid'));
            }
          }
          function C() {
            return function (t) {
              var e;
              return function (r) {
                for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                  o[i - 1] = arguments[i];
                clearTimeout(e),
                  (e = setTimeout(function () {
                    return r.apply(void 0, o);
                  }, t));
              };
            };
          }
          function D() {
            return function (t) {
              var e = !1;
              return function (r) {
                for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                  o[i - 1] = arguments[i];
                e ||
                  ((e = !0),
                  setTimeout(function () {
                    r.apply(void 0, o), (e = !1);
                  }, t));
              };
            };
          }
          function N(t) {
            var e = P(
                (t = t.trim()).split(':').map(function (t) {
                  return parseInt(t);
                }),
                2,
              ),
              r = e[0],
              n = e[1],
              o = r >= 12 ? 'PM' : 'AM';
            r > 12 && (r -= 12);
            var i = r < 10 ? '0'.concat(r) : r,
              a = n < 10 ? '0'.concat(n) : n;
            return ''.concat(i, ':').concat(a, ' ').concat(o);
          }
          function G(t) {
            var e = (t = t.trim()).slice(-2, t.length),
              r = P(
                t
                  .slice(0, t.length - 2)
                  .split(':')
                  .map(function (t) {
                    return parseInt(t);
                  }),
                2,
              ),
              n = r[0],
              o = r[1];
            'PM' === e && (n += 12);
            var i = n < 10 ? '0'.concat(n) : n,
              a = o < 10 ? '0'.concat(o) : o;
            return ''.concat(i, ':').concat(a);
          }
          function R(t) {
            var e = t.serverTime,
              r = t.store,
              n = t.format,
              o = t.hoursSeparator,
              i = void 0 === o ? '-' : o,
              a = t.openingsSeparator,
              c = void 0 === a ? ',' : a;
            try {
              var u = e,
                s = 1e3 * r.hourOffset,
                l = new Date(u + s),
                d = r.openingHours[l.getDay()];
              if (!d) return { status: 'unknown' };
              if (0 === d.length) return { status: 'closed' };
              var f = P(d, 2),
                h = f[0],
                p = f[1];
              '12h' === n && (h = h.map(N));
              var v = ''.concat(h[0], ' ').concat(i, ' ').concat(h[1]);
              return (
                p &&
                  ('12h' === n && (p = p.map(N)),
                  (v += ' '.concat(c, ' ').concat(p[0], ' ').concat(i, ' ').concat(p[1]))),
                { status: 'ok', text: v }
              );
            } catch (t) {
              return { status: 'error', message: 'Cannot create opening text for store id='.concat(r.id) };
            }
          }
          function M(t, e) {
            switch (t) {
              case 'critical':
                throw new Error(e);
              case 'error':
                return console.error(e);
              case 'warning':
                return console.warn(e);
              default:
                console.log(e);
            }
          }
          function F(t) {
            return (
              (F =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              F(t)
            );
          }
          function U() {
            U = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              n = r.hasOwnProperty,
              o =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              i = 'function' == typeof Symbol ? Symbol : {},
              a = i.iterator || '@@iterator',
              c = i.asyncIterator || '@@asyncIterator',
              u = i.toStringTag || '@@toStringTag';
            function s(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              s({}, '');
            } catch (t) {
              s = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function l(t, e, r, n) {
              var i = e && e.prototype instanceof m ? e : m,
                a = Object.create(i.prototype),
                c = new I(n || []);
              return o(a, '_invoke', { value: _(t, r, c) }), a;
            }
            function d(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = l;
            var f = 'suspendedStart',
              h = 'suspendedYield',
              p = 'executing',
              v = 'completed',
              y = {};
            function m() {}
            function g() {}
            function b() {}
            var w = {};
            s(w, a, function () {
              return this;
            });
            var x = Object.getPrototypeOf,
              E = x && x(x(j([])));
            E && E !== r && n.call(E, a) && (w = E);
            var L = (b.prototype = m.prototype = Object.create(w));
            function O(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                s(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function S(t, e) {
              function r(o, i, a, c) {
                var u = d(t[o], t, i);
                if ('throw' !== u.type) {
                  var s = u.arg,
                    l = s.value;
                  return l && 'object' == F(l) && n.call(l, '__await')
                    ? e.resolve(l.__await).then(
                        function (t) {
                          r('next', t, a, c);
                        },
                        function (t) {
                          r('throw', t, a, c);
                        },
                      )
                    : e.resolve(l).then(
                        function (t) {
                          (s.value = t), a(s);
                        },
                        function (t) {
                          return r('throw', t, a, c);
                        },
                      );
                }
                c(u.arg);
              }
              var i;
              o(this, '_invoke', {
                value: function (t, n) {
                  function o() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (i = i ? i.then(o, o) : o());
                },
              });
            }
            function _(e, r, n) {
              var o = f;
              return function (i, a) {
                if (o === p) throw new Error('Generator is already running');
                if (o === v) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = P(c, n);
                    if (u) {
                      if (u === y) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === f) throw ((o = v), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = p;
                  var s = d(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? v : h), s.arg === y)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function P(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), P(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  y
                );
              var i = d(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    y)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  y);
            }
            function A(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function k(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function I(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(A, this), this.reset(!0);
            }
            function j(e) {
              if (e || '' === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (i.next = i);
                }
              }
              throw new TypeError(F(e) + ' is not iterable');
            }
            return (
              (g.prototype = b),
              o(L, 'constructor', { value: b, configurable: !0 }),
              o(b, 'constructor', { value: g, configurable: !0 }),
              (g.displayName = s(b, u, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, b)
                    : ((t.__proto__ = b), s(t, u, 'GeneratorFunction')),
                  (t.prototype = Object.create(L)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              O(S.prototype),
              s(S.prototype, c, function () {
                return this;
              }),
              (e.AsyncIterator = S),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new S(l(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              O(L),
              s(L, u, 'Generator'),
              s(L, a, function () {
                return this;
              }),
              s(L, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = j),
              (I.prototype = {
                constructor: I,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(k),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function o(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                    var a = this.tryEntries[i],
                      c = a.completion;
                    if ('root' === a.tryLoc) return o('end');
                    if (a.tryLoc <= this.prev) {
                      var u = n.call(a, 'catchLoc'),
                        s = n.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                      var i = o;
                      break;
                    }
                  }
                  i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                  var a = i ? i.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    i ? ((this.method = 'next'), (this.next = i.finallyLoc), y) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    y
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), k(r), y;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        k(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: j(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    y
                  );
                },
              }),
              e
            );
          }
          function Y(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function H(t) {
            return function () {
              var e = this,
                r = arguments;
              return new Promise(function (n, o) {
                var i = t.apply(e, r);
                function a(t) {
                  Y(i, n, o, a, c, 'next', t);
                }
                function c(t) {
                  Y(i, n, o, a, c, 'throw', t);
                }
                a(void 0);
              });
            };
          }
          var B = 6371,
            K = 2e4,
            J = z({ latitude: 44.8054695, longitude: 10.3367158, type: 'default', origin: 'cached' });
          function z(t) {
            var e, r, n;
            return {
              latitude: t.latitude,
              longitude: t.longitude,
              accuracy: null !== (e = t.accuracy) && void 0 !== e ? e : 1,
              type: null !== (r = t.type) && void 0 !== r ? r : 'fixed',
              origin: null !== (n = t.origin) && void 0 !== n ? n : 'unknown',
            };
          }
          function q(t) {
            return V.apply(this, arguments);
          }
          function V() {
            return (V = H(
              U().mark(function t(e) {
                var r, n;
                return U().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        if (!(r = b(L))) {
                          t.next = 5;
                          break;
                        }
                        (r.origin = 'cached'), (t.next = 17);
                        break;
                      case 5:
                        return (t.next = 7), $();
                      case 7:
                        (n = t.sent), (t.t0 = n.type), (t.next = 'error' === t.t0 ? 11 : 'ok' === t.t0 ? 12 : 16);
                        break;
                      case 11:
                        return t.abrupt('break', 17);
                      case 12:
                        return ((r = n.position).type = 'html5'), (r.origin = 'fetched'), t.abrupt('break', 17);
                      case 16:
                        M('error', 'Invalid GeolocationResult type (HTML5)');
                      case 17:
                        return (
                          r || (r = e),
                          g(L, { value: JSON.stringify(r), expiration: T(15, 'minutes') }),
                          t.abrupt('return', r)
                        );
                      case 20:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              }),
            )).apply(this, arguments);
          }
          function $() {
            if (!navigator.geolocation) throw new Error();
            return new Promise(function (t) {
              navigator.geolocation.getCurrentPosition(
                function (e) {
                  if (e.coords.accuracy > K) return t({ type: 'error', message: 'position accuracy is not enough' });
                  var r = z({
                    latitude: e.coords.latitude,
                    longitude: e.coords.longitude,
                    accuracy: e.coords.accuracy,
                  });
                  t({ type: 'ok', position: r });
                },
                function (e) {
                  return t({ type: 'error', message: e.message });
                },
                { enableHighAccuracy: !0, timeout: 5e3, maximumAge: 0 },
              );
            });
          }
          function W(t) {
            return Z.apply(this, arguments);
          }
          function Z() {
            return (Z = H(
              U().mark(function t(e) {
                var r, n;
                return U().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        if (!(r = b(E))) {
                          t.next = 5;
                          break;
                        }
                        (r.origin = 'cached'), (t.next = 17);
                        break;
                      case 5:
                        return (t.next = 7), X(e);
                      case 7:
                        (n = t.sent), (t.t0 = n.type), (t.next = 'error' === t.t0 ? 11 : 'ok' === t.t0 ? 12 : 16);
                        break;
                      case 11:
                        return t.abrupt('break', 17);
                      case 12:
                        return ((r = n.position).type = 'ip'), (r.origin = 'fetched'), t.abrupt('break', 17);
                      case 16:
                        M('error', 'Invalid GeolocationResult type (IP)');
                      case 17:
                        return (
                          r || (r = J),
                          g(E, { value: JSON.stringify(r), expiration: T(1, 'hours') }),
                          t.abrupt('return', r)
                        );
                      case 20:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              }),
            )).apply(this, arguments);
          }
          function X(t) {
            return Q.apply(this, arguments);
          }
          function Q() {
            return (Q = H(
              U().mark(function t(e) {
                var r, n, o;
                return U().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return (
                          (t.next = 2),
                          fetch(u.defaultPositionGetURL(), {
                            method: 'POST',
                            headers: { Accept: 'application/json', authorization: 'Bearer '.concat(e) },
                          })
                        );
                      case 2:
                        if (200 === (n = t.sent).status) {
                          t.next = 5;
                          break;
                        }
                        return t.abrupt('return', {
                          type: 'error',
                          message: '[ERROR]: response status '.concat(n.status),
                        });
                      case 5:
                        return (t.next = 7), n.json();
                      case 7:
                        return (
                          (o = t.sent),
                          t.abrupt('return', {
                            type: 'ok',
                            position: z({
                              latitude: o.latitude,
                              longitude: o.longitude,
                              accuracy: null !== (r = o.accuracy) && void 0 !== r ? r : 1,
                            }),
                          })
                        );
                      case 9:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              }),
            )).apply(this, arguments);
          }
          var tt = function (t) {
            return 0.0174533 * t;
          };
          function et(t, e) {
            var r = tt(t),
              n = tt(e);
            return function (t, e) {
              var o = tt(t),
                i = tt(e);
              return Math.acos(Math.sin(r) * Math.sin(o) + Math.cos(r) * Math.cos(o) * Math.cos(n - i)) * B * 1e3;
            };
          }
          function rt(t, e, r) {
            if (!e || !r) return !0;
            var n = (e.longitude, r.longitude, t.longitude >= r.longitude || t.longitude <= e.longitude);
            return t.latitude >= r.latitude && t.latitude <= e.latitude && n;
          }
          function nt(t) {
            return { lat: t.latitude, lng: t.longitude };
          }
          function ot(t) {
            return [t.latitude, t.longitude];
          }
          function it(t) {
            return (
              (it =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              it(t)
            );
          }
          function at() {
            at = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              n = r.hasOwnProperty,
              o =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              i = 'function' == typeof Symbol ? Symbol : {},
              a = i.iterator || '@@iterator',
              c = i.asyncIterator || '@@asyncIterator',
              u = i.toStringTag || '@@toStringTag';
            function s(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              s({}, '');
            } catch (t) {
              s = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function l(t, e, r, n) {
              var i = e && e.prototype instanceof m ? e : m,
                a = Object.create(i.prototype),
                c = new I(n || []);
              return o(a, '_invoke', { value: _(t, r, c) }), a;
            }
            function d(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = l;
            var f = 'suspendedStart',
              h = 'suspendedYield',
              p = 'executing',
              v = 'completed',
              y = {};
            function m() {}
            function g() {}
            function b() {}
            var w = {};
            s(w, a, function () {
              return this;
            });
            var x = Object.getPrototypeOf,
              E = x && x(x(j([])));
            E && E !== r && n.call(E, a) && (w = E);
            var L = (b.prototype = m.prototype = Object.create(w));
            function O(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                s(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function S(t, e) {
              function r(o, i, a, c) {
                var u = d(t[o], t, i);
                if ('throw' !== u.type) {
                  var s = u.arg,
                    l = s.value;
                  return l && 'object' == it(l) && n.call(l, '__await')
                    ? e.resolve(l.__await).then(
                        function (t) {
                          r('next', t, a, c);
                        },
                        function (t) {
                          r('throw', t, a, c);
                        },
                      )
                    : e.resolve(l).then(
                        function (t) {
                          (s.value = t), a(s);
                        },
                        function (t) {
                          return r('throw', t, a, c);
                        },
                      );
                }
                c(u.arg);
              }
              var i;
              o(this, '_invoke', {
                value: function (t, n) {
                  function o() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (i = i ? i.then(o, o) : o());
                },
              });
            }
            function _(e, r, n) {
              var o = f;
              return function (i, a) {
                if (o === p) throw new Error('Generator is already running');
                if (o === v) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = P(c, n);
                    if (u) {
                      if (u === y) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === f) throw ((o = v), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = p;
                  var s = d(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? v : h), s.arg === y)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function P(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), P(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  y
                );
              var i = d(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    y)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  y);
            }
            function A(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function k(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function I(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(A, this), this.reset(!0);
            }
            function j(e) {
              if (e || '' === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (i.next = i);
                }
              }
              throw new TypeError(it(e) + ' is not iterable');
            }
            return (
              (g.prototype = b),
              o(L, 'constructor', { value: b, configurable: !0 }),
              o(b, 'constructor', { value: g, configurable: !0 }),
              (g.displayName = s(b, u, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, b)
                    : ((t.__proto__ = b), s(t, u, 'GeneratorFunction')),
                  (t.prototype = Object.create(L)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              O(S.prototype),
              s(S.prototype, c, function () {
                return this;
              }),
              (e.AsyncIterator = S),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new S(l(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              O(L),
              s(L, u, 'Generator'),
              s(L, a, function () {
                return this;
              }),
              s(L, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = j),
              (I.prototype = {
                constructor: I,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(k),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function o(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                    var a = this.tryEntries[i],
                      c = a.completion;
                    if ('root' === a.tryLoc) return o('end');
                    if (a.tryLoc <= this.prev) {
                      var u = n.call(a, 'catchLoc'),
                        s = n.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                      var i = o;
                      break;
                    }
                  }
                  i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                  var a = i ? i.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    i ? ((this.method = 'next'), (this.next = i.finallyLoc), y) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    y
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), k(r), y;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        k(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: j(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    y
                  );
                },
              }),
              e
            );
          }
          function ct(t, e, r) {
            var n;
            return (
              (n = (function (t, e) {
                if ('object' != it(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                  var n = r.call(t, 'string');
                  if ('object' != it(n)) return n;
                  throw new TypeError('@@toPrimitive must return a primitive value.');
                }
                return String(t);
              })(e)),
              (e = 'symbol' == it(n) ? n : String(n)) in t
                ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
                : (t[e] = r),
              t
            );
          }
          function ut(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function st(t, e, r) {
            if (!(t.accuracy > 2e3))
              for (var n = et(t.latitude, t.longitude), o = 0, i = 0; i < e.length; ++i)
                (o = n(e[i].latitude, e[i].longitude)) < 1e3 && r(e[i].id, 1e3),
                  o < 5e3 && r(e[i].id, 5e3),
                  o < 1e4 && r(e[i].id, 1e4),
                  o < 2e4 && r(e[i].id, 2e4);
          }
          function lt(t, e, r, n, o) {
            return dt.apply(this, arguments);
          }
          function dt() {
            var t;
            return (
              (t = at().mark(function t(e, r, n, o, i) {
                var a, c, s, l, d, f;
                return at().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return (
                          (t.next = 2),
                          fetch(u.intersectingIsochronesGetURL(), {
                            method: 'POST',
                            headers: { Authorization: 'Bearer '.concat(process.env.RETAILTUNE_KEY) },
                            body: JSON.stringify({ latitude: e.latitude, longitude: e.longitude }),
                          })
                        );
                      case 2:
                        if ((a = t.sent).ok) {
                          t.next = 5;
                          break;
                        }
                        throw new Error('Unable to fetch isochrones data for user position. status='.concat(a.status));
                      case 5:
                        return (t.next = 7), a.json();
                      case 7:
                        for (c = t.sent, s = new Array(c.length), l = 0; l < c.length; ++l)
                          (s[l] = c[l].store_id), o(s[l], c[l]);
                        return (
                          (t.next = 12),
                          fetch(u.productAvailabilityInStoresURL(), {
                            method: 'POST',
                            headers: { Authorization: 'Bearer '.concat(process.env.RETAILTUNE_KEY) },
                            body: JSON.stringify(ct(ct({}, r, n), 'store_ids', s)),
                          })
                        );
                      case 12:
                        if ((a = t.sent).ok) {
                          t.next = 15;
                          break;
                        }
                        throw new Error(
                          'Unable to fetch product availabilities for product '
                            .concat(r, '=')
                            .concat(n, '. status=')
                            .concat(a.status),
                        );
                      case 15:
                        return (t.next = 17), a.json();
                      case 17:
                        for (d = t.sent, f = 0; f < c.length; ++f) d[c[f].store_id] && i(c[f].store_id, c[f]);
                      case 19:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              })),
              (dt = function () {
                var e = this,
                  r = arguments;
                return new Promise(function (n, o) {
                  var i = t.apply(e, r);
                  function a(t) {
                    ut(i, n, o, a, c, 'next', t);
                  }
                  function c(t) {
                    ut(i, n, o, a, c, 'throw', t);
                  }
                  a(void 0);
                });
              }),
              dt.apply(this, arguments)
            );
          }
          function ft(t) {
            return (
              (ft =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              ft(t)
            );
          }
          function ht() {
            ht = function () {
              return e;
            };
            var t,
              e = {},
              r = Object.prototype,
              n = r.hasOwnProperty,
              o =
                Object.defineProperty ||
                function (t, e, r) {
                  t[e] = r.value;
                },
              i = 'function' == typeof Symbol ? Symbol : {},
              a = i.iterator || '@@iterator',
              c = i.asyncIterator || '@@asyncIterator',
              u = i.toStringTag || '@@toStringTag';
            function s(t, e, r) {
              return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
            }
            try {
              s({}, '');
            } catch (t) {
              s = function (t, e, r) {
                return (t[e] = r);
              };
            }
            function l(t, e, r, n) {
              var i = e && e.prototype instanceof m ? e : m,
                a = Object.create(i.prototype),
                c = new I(n || []);
              return o(a, '_invoke', { value: _(t, r, c) }), a;
            }
            function d(t, e, r) {
              try {
                return { type: 'normal', arg: t.call(e, r) };
              } catch (t) {
                return { type: 'throw', arg: t };
              }
            }
            e.wrap = l;
            var f = 'suspendedStart',
              h = 'suspendedYield',
              p = 'executing',
              v = 'completed',
              y = {};
            function m() {}
            function g() {}
            function b() {}
            var w = {};
            s(w, a, function () {
              return this;
            });
            var x = Object.getPrototypeOf,
              E = x && x(x(j([])));
            E && E !== r && n.call(E, a) && (w = E);
            var L = (b.prototype = m.prototype = Object.create(w));
            function O(t) {
              ['next', 'throw', 'return'].forEach(function (e) {
                s(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function S(t, e) {
              function r(o, i, a, c) {
                var u = d(t[o], t, i);
                if ('throw' !== u.type) {
                  var s = u.arg,
                    l = s.value;
                  return l && 'object' == ft(l) && n.call(l, '__await')
                    ? e.resolve(l.__await).then(
                        function (t) {
                          r('next', t, a, c);
                        },
                        function (t) {
                          r('throw', t, a, c);
                        },
                      )
                    : e.resolve(l).then(
                        function (t) {
                          (s.value = t), a(s);
                        },
                        function (t) {
                          return r('throw', t, a, c);
                        },
                      );
                }
                c(u.arg);
              }
              var i;
              o(this, '_invoke', {
                value: function (t, n) {
                  function o() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return (i = i ? i.then(o, o) : o());
                },
              });
            }
            function _(e, r, n) {
              var o = f;
              return function (i, a) {
                if (o === p) throw new Error('Generator is already running');
                if (o === v) {
                  if ('throw' === i) throw a;
                  return { value: t, done: !0 };
                }
                for (n.method = i, n.arg = a; ; ) {
                  var c = n.delegate;
                  if (c) {
                    var u = P(c, n);
                    if (u) {
                      if (u === y) continue;
                      return u;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (o === f) throw ((o = v), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  o = p;
                  var s = d(e, r, n);
                  if ('normal' === s.type) {
                    if (((o = n.done ? v : h), s.arg === y)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            }
            function P(e, r) {
              var n = r.method,
                o = e.iterator[n];
              if (o === t)
                return (
                  (r.delegate = null),
                  ('throw' === n &&
                    e.iterator.return &&
                    ((r.method = 'return'), (r.arg = t), P(e, r), 'throw' === r.method)) ||
                    ('return' !== n &&
                      ((r.method = 'throw'),
                      (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
                  y
                );
              var i = d(o, e.iterator, r.arg);
              if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
              var a = i.arg;
              return a
                ? a.done
                  ? ((r[e.resultName] = a.value),
                    (r.next = e.nextLoc),
                    'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
                    (r.delegate = null),
                    y)
                  : a
                : ((r.method = 'throw'),
                  (r.arg = new TypeError('iterator result is not an object')),
                  (r.delegate = null),
                  y);
            }
            function A(t) {
              var e = { tryLoc: t[0] };
              1 in t && (e.catchLoc = t[1]),
                2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
                this.tryEntries.push(e);
            }
            function k(t) {
              var e = t.completion || {};
              (e.type = 'normal'), delete e.arg, (t.completion = e);
            }
            function I(t) {
              (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(A, this), this.reset(!0);
            }
            function j(e) {
              if (e || '' === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ('function' == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                      return (r.value = t), (r.done = !0), r;
                    };
                  return (i.next = i);
                }
              }
              throw new TypeError(ft(e) + ' is not iterable');
            }
            return (
              (g.prototype = b),
              o(L, 'constructor', { value: b, configurable: !0 }),
              o(b, 'constructor', { value: g, configurable: !0 }),
              (g.displayName = s(b, u, 'GeneratorFunction')),
              (e.isGeneratorFunction = function (t) {
                var e = 'function' == typeof t && t.constructor;
                return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name));
              }),
              (e.mark = function (t) {
                return (
                  Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, b)
                    : ((t.__proto__ = b), s(t, u, 'GeneratorFunction')),
                  (t.prototype = Object.create(L)),
                  t
                );
              }),
              (e.awrap = function (t) {
                return { __await: t };
              }),
              O(S.prototype),
              s(S.prototype, c, function () {
                return this;
              }),
              (e.AsyncIterator = S),
              (e.async = function (t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new S(l(t, r, n, o), i);
                return e.isGeneratorFunction(r)
                  ? a
                  : a.next().then(function (t) {
                      return t.done ? t.value : a.next();
                    });
              }),
              O(L),
              s(L, u, 'Generator'),
              s(L, a, function () {
                return this;
              }),
              s(L, 'toString', function () {
                return '[object Generator]';
              }),
              (e.keys = function (t) {
                var e = Object(t),
                  r = [];
                for (var n in e) r.push(n);
                return (
                  r.reverse(),
                  function t() {
                    for (; r.length; ) {
                      var n = r.pop();
                      if (n in e) return (t.value = n), (t.done = !1), t;
                    }
                    return (t.done = !0), t;
                  }
                );
              }),
              (e.values = j),
              (I.prototype = {
                constructor: I,
                reset: function (e) {
                  if (
                    ((this.prev = 0),
                    (this.next = 0),
                    (this.sent = this._sent = t),
                    (this.done = !1),
                    (this.delegate = null),
                    (this.method = 'next'),
                    (this.arg = t),
                    this.tryEntries.forEach(k),
                    !e)
                  )
                    for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function () {
                  this.done = !0;
                  var t = this.tryEntries[0].completion;
                  if ('throw' === t.type) throw t.arg;
                  return this.rval;
                },
                dispatchException: function (e) {
                  if (this.done) throw e;
                  var r = this;
                  function o(n, o) {
                    return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
                  }
                  for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                    var a = this.tryEntries[i],
                      c = a.completion;
                    if ('root' === a.tryLoc) return o('end');
                    if (a.tryLoc <= this.prev) {
                      var u = n.call(a, 'catchLoc'),
                        s = n.call(a, 'finallyLoc');
                      if (u && s) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      } else if (u) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      } else {
                        if (!s) throw new Error('try statement without catch or finally');
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function (t, e) {
                  for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                      var i = o;
                      break;
                    }
                  }
                  i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                  var a = i ? i.completion : {};
                  return (
                    (a.type = t),
                    (a.arg = e),
                    i ? ((this.method = 'next'), (this.next = i.finallyLoc), y) : this.complete(a)
                  );
                },
                complete: function (t, e) {
                  if ('throw' === t.type) throw t.arg;
                  return (
                    'break' === t.type || 'continue' === t.type
                      ? (this.next = t.arg)
                      : 'return' === t.type
                      ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                      : 'normal' === t.type && e && (this.next = e),
                    y
                  );
                },
                finish: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), k(r), y;
                  }
                },
                catch: function (t) {
                  for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                      var n = r.completion;
                      if ('throw' === n.type) {
                        var o = n.arg;
                        k(r);
                      }
                      return o;
                    }
                  }
                  throw new Error('illegal catch attempt');
                },
                delegateYield: function (e, r, n) {
                  return (
                    (this.delegate = { iterator: j(e), resultName: r, nextLoc: n }),
                    'next' === this.method && (this.arg = t),
                    y
                  );
                },
              }),
              e
            );
          }
          function pt(t, e, r) {
            var n;
            return (
              (n = (function (t, e) {
                if ('object' != ft(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                  var n = r.call(t, 'string');
                  if ('object' != ft(n)) return n;
                  throw new TypeError('@@toPrimitive must return a primitive value.');
                }
                return String(t);
              })(e)),
              (e = 'symbol' == ft(n) ? n : String(n)) in t
                ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
                : (t[e] = r),
              t
            );
          }
          function vt(t, e, r, n, o, i, a) {
            try {
              var c = t[i](a),
                u = c.value;
            } catch (t) {
              return void r(t);
            }
            c.done ? e(u) : Promise.resolve(u).then(n, o);
          }
          function yt(t) {
            return function () {
              var e = this,
                r = arguments;
              return new Promise(function (n, o) {
                var i = t.apply(e, r);
                function a(t) {
                  vt(i, n, o, a, c, 'next', t);
                }
                function c(t) {
                  vt(i, n, o, a, c, 'throw', t);
                }
                a(void 0);
              });
            };
          }
          var mt = (function () {
            var t = yt(
              ht().mark(function t(e, r, n) {
                var o, i, a, c, u;
                return ht().wrap(function (t) {
                  for (;;)
                    switch ((t.prev = t.next)) {
                      case 0:
                        return (
                          (o =
                            'sku' === e
                              ? 'https://endpoint.retailtune.com/endpoint/v1/product-sku-availabilities/getall'
                              : 'https://endpoint.retailtune.com/endpoint/v1/product-sku-model-availabilities/'),
                          (i = { key: process.env.RETAILTUNE_KEY, query: pt({}, e, r) }),
                          (t.next = 4),
                          fetch(o, { method: 'POST', body: JSON.stringify(i) })
                        );
                      case 4:
                        if ((a = t.sent).ok) {
                          t.next = 7;
                          break;
                        }
                        throw new Error('Cannot fetch product availabilities: status '.concat(a.status));
                      case 7:
                        return (t.next = 9), a.json();
                      case 9:
                        if ('ok' === (c = t.sent).result) {
                          t.next = 12;
                          break;
                        }
                        throw new Error('Cannot fetch product availabilities: '.concat(c.result));
                      case 12:
                        for (u = 0; u < c.response.length; ++u)
                          n.set(c.response[u].store_id, c.response[u].availability > 0);
                      case 13:
                      case 'end':
                        return t.stop();
                    }
                }, t);
              }),
            );
            return function (e, r, n) {
              return t.apply(this, arguments);
            };
          })();
          function gt(t) {
            return bt.apply(this, arguments);
          }
          function bt() {
            return (bt = yt(
              ht().mark(function t(e) {
                return ht().wrap(
                  function (t) {
                    for (;;)
                      switch ((t.prev = t.next)) {
                        case 0:
                          return (e.positionConsent = !0), (t.prev = 1), (t.next = 4), W(process.env.RETAILTUNE_KEY);
                        case 4:
                          (e.defaultPosition = t.sent), (t.next = 11);
                          break;
                        case 7:
                          (t.prev = 7),
                            (t.t0 = t.catch(1)),
                            console.warn(
                              'An error occurred while fetching the default position: fallback position used',
                            ),
                            (e.defaultPosition = J);
                        case 11:
                          return (t.prev = 11), (t.next = 14), q(e.defaultPosition);
                        case 14:
                          (e.userPosition = t.sent), (t.next = 21);
                          break;
                        case 17:
                          (t.prev = 17),
                            (t.t1 = t.catch(11)),
                            console.warn('An error occurred while fetching the user position: default position used'),
                            (e.userPosition = e.defaultPosition);
                        case 21:
                          e.cachedPositionConsent ||
                            (g(x, { expiration: T(1, 'years'), value: JSON.stringify(!0) }),
                            (e.cachedPositionConsent = !0)),
                            e.cachedDefaultPosition ||
                              (g(E, { expiration: T(1, 'hours'), value: JSON.stringify(e.defaultPosition) }),
                              (e.cachedDefaultPosition = e.defaultPosition)),
                            e.cachedUserPosition ||
                              (g(L, { expiration: T(15, 'minutes'), value: JSON.stringify(e.userPosition) }),
                              (e.cachedUserPosition = e.userPosition));
                        case 24:
                        case 'end':
                          return t.stop();
                      }
                  },
                  t,
                  null,
                  [
                    [1, 7],
                    [11, 17],
                  ],
                );
              }),
            )).apply(this, arguments);
          }
          function wt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
          }
          function xt(t) {
            return t.hasOwnProperty('priority');
          }
          function Et(t) {
            return t.hasOwnProperty('typePriority');
          }
          function Lt(t, e) {
            return t.distance && e.distance ? (t.distance < e.distance ? -1 : t.distance > e.distance ? 1 : 0) : 0;
          }
          function Ot(t, e) {
            if (xt(t) && xt(e)) return t.priority > e.priority ? 1 : t.priority < e.priority ? -1 : Lt(t, e);
            if (Et(t) && Et(e))
              return t.typePriority > e.typePriority ? 1 : t.typePriority < e.typePriority ? -1 : Lt(t, e);
            throw new Error('sortStoresByPriority: A and B types must be the same');
          }
          var St = function (t) {
            var e, r;
            t < 1e3 ? ((e = 'm'), (r = t)) : ((e = 'Km'), (r = t / 1e3));
            var n,
              o =
                (function (t) {
                  if (Array.isArray(t)) return t;
                })((n = ''.concat(r).split('.'))) ||
                (function (t, e) {
                  var r = null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                  if (null != r) {
                    var n,
                      o,
                      i,
                      a,
                      c = [],
                      u = !0,
                      s = !1;
                    try {
                      for (
                        i = (r = r.call(t)).next;
                        !(u = (n = i.call(r)).done) && (c.push(n.value), 2 !== c.length);
                        u = !0
                      );
                    } catch (t) {
                      (s = !0), (o = t);
                    } finally {
                      try {
                        if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
                      } finally {
                        if (s) throw o;
                      }
                    }
                    return c;
                  }
                })(n) ||
                (function (t, e) {
                  if (t) {
                    if ('string' == typeof t) return wt(t, 2);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return (
                      'Object' === r && t.constructor && (r = t.constructor.name),
                      'Map' === r || 'Set' === r
                        ? Array.from(t)
                        : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                        ? wt(t, 2)
                        : void 0
                    );
                  }
                })(n) ||
                (function () {
                  throw new TypeError(
                    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                  );
                })(),
              i = o[0],
              a = o[1];
            if (0 === a.length) return ''.concat(i, ' ').concat(e);
            var c = a[0],
              u = a.length > 1 ? a[1] : 0;
            return ''.concat(i, '.').concat(c).concat(u, ' ').concat(e);
          };
          function _t(t, e, r) {
            for (
              var n,
                o = 1e3 * (r = null !== (n = r) && void 0 !== n ? n : 100),
                i = et(t.latitude, t.longitude),
                a = null,
                c = 0;
              c < e.length;
              ++c
            )
              (e[c].distance = i(e[c].latitude, e[c].longitude)),
                e[c].distance > o || ((!a || a.distance > e[c].distance) && (a = e[c]));
            return a;
          }
          var Pt = function (t) {
            var e = t.getBoundingClientRect();
            return (
              e.top >= 0 &&
              e.left >= 0 &&
              e.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              e.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
          };
          e.uP = r.createDebounceFn;
        })();
      },
      561: (t, e) => {
        (() => {
          'use strict';
          var t = {
              d: (e, r) => {
                for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: r[n] });
              },
              o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
              r: (t) => {
                'undefined' != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
                  Object.defineProperty(t, '__esModule', { value: !0 });
              },
            },
            r = {};
          function n(t) {
            return (
              (function (t) {
                if (Array.isArray(t)) return i(t);
              })(t) ||
              (function (t) {
                if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                  return Array.from(t);
              })(t) ||
              o(t) ||
              (function () {
                throw new TypeError(
                  'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                );
              })()
            );
          }
          function o(t, e) {
            if (t) {
              if ('string' == typeof t) return i(t, e);
              var r = Object.prototype.toString.call(t).slice(8, -1);
              return (
                'Object' === r && t.constructor && (r = t.constructor.name),
                'Map' === r || 'Set' === r
                  ? Array.from(t)
                  : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                  ? i(t, e)
                  : void 0
              );
            }
          }
          function i(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
            return n;
          }
          function a(t) {
            return (
              (a =
                'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t;
                    }),
              a(t)
            );
          }
          t.r(r), t.d(r, { Fragment: () => c, jsx: () => s, jsxs: () => l });
          var c = Symbol.for('El.fragment');
          function u(t) {
            for (var e = t.flat(), r = [], n = 0; n < e.length; ++n)
              'boolean' != typeof e[n] && void 0 !== e[n] && null !== e[n] && r.push(e[n]);
            return r;
          }
          var s = function (t, e) {
              var r = null;
              if (
                (e && void 0 !== e.children && (r = Array.isArray(e.children) ? u(e.children) : u([e.children])),
                'symbol' === a(t))
              ) {
                if (t.valueOf() === c.valueOf()) {
                  var i = document.createDocumentFragment();
                  return r && r.length > 0 && i.append.apply(i, n(r)), i;
                }
                throw new Error("JSX Error: invalid symbol '".concat(t.valueOf, "'"));
              }
              var s = document.createElement(t);
              return (
                e &&
                  Object.entries(e).forEach(function (t) {
                    var e,
                      r =
                        (function (t) {
                          if (Array.isArray(t)) return t;
                        })((e = t)) ||
                        (function (t, e) {
                          var r =
                            null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                          if (null != r) {
                            var n,
                              o,
                              i,
                              a,
                              c = [],
                              u = !0,
                              s = !1;
                            try {
                              for (
                                i = (r = r.call(t)).next;
                                !(u = (n = i.call(r)).done) && (c.push(n.value), 2 !== c.length);
                                u = !0
                              );
                            } catch (t) {
                              (s = !0), (o = t);
                            } finally {
                              try {
                                if (!u && null != r.return && ((a = r.return()), Object(a) !== a)) return;
                              } finally {
                                if (s) throw o;
                              }
                            }
                            return c;
                          }
                        })(e) ||
                        o(e, 2) ||
                        (function () {
                          throw new TypeError(
                            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                          );
                        })(),
                      n = r[0],
                      i = r[1];
                    if ('children' !== n)
                      if ('class' !== n)
                        n.indexOf('-') > -1
                          ? 'string' == typeof i
                            ? s.setAttribute(n, i)
                            : i.toString && 'function' == typeof i.toString && s.setAttribute(n, i.toString())
                          : (s[n] = i);
                      else {
                        var a,
                          c = (function (t, e) {
                            var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                            if (!r) {
                              if (Array.isArray(t) || (r = o(t))) {
                                r && (t = r);
                                var n = 0,
                                  i = function () {};
                                return {
                                  s: i,
                                  n: function () {
                                    return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
                                  },
                                  e: function (t) {
                                    throw t;
                                  },
                                  f: i,
                                };
                              }
                              throw new TypeError(
                                'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                              );
                            }
                            var a,
                              c = !0,
                              u = !1;
                            return {
                              s: function () {
                                r = r.call(t);
                              },
                              n: function () {
                                var t = r.next();
                                return (c = t.done), t;
                              },
                              e: function (t) {
                                (u = !0), (a = t);
                              },
                              f: function () {
                                try {
                                  c || null == r.return || r.return();
                                } finally {
                                  if (u) throw a;
                                }
                              },
                            };
                          })(i.trim().replace(/\s+/, ' ').split(' '));
                        try {
                          for (c.s(); !(a = c.n()).done; ) {
                            var u = a.value;
                            s.classList.add(u);
                          }
                        } catch (t) {
                          c.e(t);
                        } finally {
                          c.f();
                        }
                      }
                  }),
                r && r.length > 0 && s.append.apply(s, n(r)),
                s
              );
            },
            l = s;
          (e.FK = r.Fragment), (e.Y = r.jsx), (e.FD = r.jsxs);
        })();
      },
    },
    e = {};
  function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = (e[n] = { exports: {} });
    return t[n](i, i.exports, r), i.exports;
  }
  (r.d = (t, e) => {
    for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
  }),
    (r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (r.r = (t) => {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    });
  var n = {};
  (() => {
    'use strict';
    function t(t) {
      var e, r;
      if ('string' == typeof t.anchor) {
        if (!(e = document.getElementById(t.anchor)))
          throw new Error(
            ((r = "(prop=anchorId) cannot find DOM node with ID: '".concat(t.anchor, "'")), '[ACCORDION] '.concat(r)),
          );
      } else e = t.anchor;
      var n = e,
        o = !1,
        i = document.createElement('div');
      i.classList.add('rt-accordion-item');
      var a = document.createElement('div');
      a.classList.add('rt-accordion-bar'),
        a.addEventListener('click', function (t) {
          t.stopPropagation(), d(!o);
        });
      var c = document.createElement('span');
      c.classList.add('rt-accordion-title');
      var u = document.createElement('div');
      function s(t) {
        (c.innerHTML = ''), 'string' == typeof t ? (c.innerHTML = t) : c.appendChild(t);
      }
      function l(t) {
        (u.innerHTML = ''), u.appendChild(t);
      }
      function d(t) {
        t
          ? ((o = !0), i.classList.add('rt-accordion-item--opened'))
          : ((o = !1), i.classList.remove('rt-accordion-item--opened'));
      }
      return (
        u.classList.add('rt-accordion-content'),
        s(t.heading),
        l(t.content),
        a.appendChild(c),
        i.appendChild(a),
        i.appendChild(u),
        n.appendChild(i),
        t.isOpen && d(!0),
        [s, l]
      );
    }
    r.r(n),
      r.d(n, {
        ARIA_Autocomplete: () => M,
        ARIA_createAccordion: () => A,
        ARIA_createSelect: () => Y,
        DEPRECATED__ARIA_createSelect: () => J,
        createAccordion: () => t,
        createAutocomplete: () => c,
        createScrollButton: () => s,
        createSelect: () => f,
        createSidebar: () => d,
        createTable: () => w,
        createToastMessagesContainer: () => m,
        updateCurrentPage: () => P,
        updateRows: () => S,
        updateRowsPerPage: () => _,
      });
    var e = r(412);
    function o(t) {
      return (
        (o =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t;
              }),
        o(t)
      );
    }
    function i() {
      i = function () {
        return e;
      };
      var t,
        e = {},
        r = Object.prototype,
        n = r.hasOwnProperty,
        a =
          Object.defineProperty ||
          function (t, e, r) {
            t[e] = r.value;
          },
        c = 'function' == typeof Symbol ? Symbol : {},
        u = c.iterator || '@@iterator',
        s = c.asyncIterator || '@@asyncIterator',
        l = c.toStringTag || '@@toStringTag';
      function d(t, e, r) {
        return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
      }
      try {
        d({}, '');
      } catch (t) {
        d = function (t, e, r) {
          return (t[e] = r);
        };
      }
      function f(t, e, r, n) {
        var o = e && e.prototype instanceof b ? e : b,
          i = Object.create(o.prototype),
          c = new T(n || []);
        return a(i, '_invoke', { value: A(t, r, c) }), i;
      }
      function h(t, e, r) {
        try {
          return { type: 'normal', arg: t.call(e, r) };
        } catch (t) {
          return { type: 'throw', arg: t };
        }
      }
      e.wrap = f;
      var p = 'suspendedStart',
        v = 'suspendedYield',
        y = 'executing',
        m = 'completed',
        g = {};
      function b() {}
      function w() {}
      function x() {}
      var E = {};
      d(E, u, function () {
        return this;
      });
      var L = Object.getPrototypeOf,
        O = L && L(L(C([])));
      O && O !== r && n.call(O, u) && (E = O);
      var S = (x.prototype = b.prototype = Object.create(E));
      function _(t) {
        ['next', 'throw', 'return'].forEach(function (e) {
          d(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function P(t, e) {
        function r(i, a, c, u) {
          var s = h(t[i], t, a);
          if ('throw' !== s.type) {
            var l = s.arg,
              d = l.value;
            return d && 'object' == o(d) && n.call(d, '__await')
              ? e.resolve(d.__await).then(
                  function (t) {
                    r('next', t, c, u);
                  },
                  function (t) {
                    r('throw', t, c, u);
                  },
                )
              : e.resolve(d).then(
                  function (t) {
                    (l.value = t), c(l);
                  },
                  function (t) {
                    return r('throw', t, c, u);
                  },
                );
          }
          u(s.arg);
        }
        var i;
        a(this, '_invoke', {
          value: function (t, n) {
            function o() {
              return new e(function (e, o) {
                r(t, n, e, o);
              });
            }
            return (i = i ? i.then(o, o) : o());
          },
        });
      }
      function A(e, r, n) {
        var o = p;
        return function (i, a) {
          if (o === y) throw Error('Generator is already running');
          if (o === m) {
            if ('throw' === i) throw a;
            return { value: t, done: !0 };
          }
          for (n.method = i, n.arg = a; ; ) {
            var c = n.delegate;
            if (c) {
              var u = k(c, n);
              if (u) {
                if (u === g) continue;
                return u;
              }
            }
            if ('next' === n.method) n.sent = n._sent = n.arg;
            else if ('throw' === n.method) {
              if (o === p) throw ((o = m), n.arg);
              n.dispatchException(n.arg);
            } else 'return' === n.method && n.abrupt('return', n.arg);
            o = y;
            var s = h(e, r, n);
            if ('normal' === s.type) {
              if (((o = n.done ? m : v), s.arg === g)) continue;
              return { value: s.arg, done: n.done };
            }
            'throw' === s.type && ((o = m), (n.method = 'throw'), (n.arg = s.arg));
          }
        };
      }
      function k(e, r) {
        var n = r.method,
          o = e.iterator[n];
        if (o === t)
          return (
            (r.delegate = null),
            ('throw' === n &&
              e.iterator.return &&
              ((r.method = 'return'), (r.arg = t), k(e, r), 'throw' === r.method)) ||
              ('return' !== n &&
                ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
            g
          );
        var i = h(o, e.iterator, r.arg);
        if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), g;
        var a = i.arg;
        return a
          ? a.done
            ? ((r[e.resultName] = a.value),
              (r.next = e.nextLoc),
              'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
              (r.delegate = null),
              g)
            : a
          : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), g);
      }
      function I(t) {
        var e = { tryLoc: t[0] };
        1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
      }
      function j(t) {
        var e = t.completion || {};
        (e.type = 'normal'), delete e.arg, (t.completion = e);
      }
      function T(t) {
        (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(I, this), this.reset(!0);
      }
      function C(e) {
        if (e || '' === e) {
          var r = e[u];
          if (r) return r.call(e);
          if ('function' == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var i = -1,
              a = function r() {
                for (; ++i < e.length; ) if (n.call(e, i)) return (r.value = e[i]), (r.done = !1), r;
                return (r.value = t), (r.done = !0), r;
              };
            return (a.next = a);
          }
        }
        throw new TypeError(o(e) + ' is not iterable');
      }
      return (
        (w.prototype = x),
        a(S, 'constructor', { value: x, configurable: !0 }),
        a(x, 'constructor', { value: w, configurable: !0 }),
        (w.displayName = d(x, l, 'GeneratorFunction')),
        (e.isGeneratorFunction = function (t) {
          var e = 'function' == typeof t && t.constructor;
          return !!e && (e === w || 'GeneratorFunction' === (e.displayName || e.name));
        }),
        (e.mark = function (t) {
          return (
            Object.setPrototypeOf ? Object.setPrototypeOf(t, x) : ((t.__proto__ = x), d(t, l, 'GeneratorFunction')),
            (t.prototype = Object.create(S)),
            t
          );
        }),
        (e.awrap = function (t) {
          return { __await: t };
        }),
        _(P.prototype),
        d(P.prototype, s, function () {
          return this;
        }),
        (e.AsyncIterator = P),
        (e.async = function (t, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new P(f(t, r, n, o), i);
          return e.isGeneratorFunction(r)
            ? a
            : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
        }),
        _(S),
        d(S, l, 'Generator'),
        d(S, u, function () {
          return this;
        }),
        d(S, 'toString', function () {
          return '[object Generator]';
        }),
        (e.keys = function (t) {
          var e = Object(t),
            r = [];
          for (var n in e) r.push(n);
          return (
            r.reverse(),
            function t() {
              for (; r.length; ) {
                var n = r.pop();
                if (n in e) return (t.value = n), (t.done = !1), t;
              }
              return (t.done = !0), t;
            }
          );
        }),
        (e.values = C),
        (T.prototype = {
          constructor: T,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = t),
              (this.done = !1),
              (this.delegate = null),
              (this.method = 'next'),
              (this.arg = t),
              this.tryEntries.forEach(j),
              !e)
            )
              for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          },
          stop: function () {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ('throw' === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var r = this;
            function o(n, o) {
              return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var a = this.tryEntries[i],
                c = a.completion;
              if ('root' === a.tryLoc) return o('end');
              if (a.tryLoc <= this.prev) {
                var u = n.call(a, 'catchLoc'),
                  s = n.call(a, 'finallyLoc');
                if (u && s) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                } else if (u) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                } else {
                  if (!s) throw Error('try statement without catch or finally');
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                }
              }
            }
          },
          abrupt: function (t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), g) : this.complete(a)
            );
          },
          complete: function (t, e) {
            if ('throw' === t.type) throw t.arg;
            return (
              'break' === t.type || 'continue' === t.type
                ? (this.next = t.arg)
                : 'return' === t.type
                ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                : 'normal' === t.type && e && (this.next = e),
              g
            );
          },
          finish: function (t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), g;
            }
          },
          catch: function (t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.tryLoc === t) {
                var n = r.completion;
                if ('throw' === n.type) {
                  var o = n.arg;
                  j(r);
                }
                return o;
              }
            }
            throw Error('illegal catch attempt');
          },
          delegateYield: function (e, r, n) {
            return (
              (this.delegate = { iterator: C(e), resultName: r, nextLoc: n }),
              'next' === this.method && (this.arg = t),
              g
            );
          },
        }),
        e
      );
    }
    function a(t, e, r, n, o, i, a) {
      try {
        var c = t[i](a),
          u = c.value;
      } catch (t) {
        return void r(t);
      }
      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }
    function c(t) {
      var r, n, o;
      if ('string' == typeof t.anchor) {
        if (!(n = document.getElementById(t.anchor)))
          throw new Error(
            ((o = "(props=anchorId) cannot find DOM element with ID: '".concat(t.anchor, "'")),
            '[AUTOCOMPLETE] '.concat(o)),
          );
      } else n = t.anchor;
      var c = n,
        u = [],
        s = null,
        l = (0, e.uP)()(300),
        d = document.createElement('div');
      d.classList.add('rt-autocomplete-wrapper'), (d.tabIndex = 0);
      var f = document.createElement('div');
      f.classList.add('rt-autocomplete');
      var h = document.createElement('div');
      h.classList.add('rt-input-container');
      var p = document.createElement('input');
      if (
        ((p.placeholder = null !== (r = t.placeholder) && void 0 !== r ? r : ''),
        p.classList.add('rt-user-input'),
        t.a11y)
      ) {
        var v = document.createElement('label');
        (v.htmlFor = t.a11y.inputId),
          (p.id = t.a11y.inputId),
          (v.textContent = t.a11y.inputLabelText),
          h.appendChild(v);
      }
      h.appendChild(p);
      var y = document.createElement('button'),
        m = document.createElement('button'),
        g = document.createElement('ul');
      g.classList.add('rt-predictions'), f.appendChild(h), f.appendChild(g), d.appendChild(f), c.appendChild(d);
      var b = function () {
          (p.value = ''),
            (u = []),
            (s = null),
            (g.innerHTML = ''),
            f.classList.remove('rt-autocomplete--open'),
            t.searchIcon && (y.disabled = !0),
            t.clearIcon && m.classList.remove('rt-icon--visible'),
            m.classList.remove('rt-icon--visible'),
            t.onAutocompleteClear && t.onAutocompleteClear();
        },
        w = function (e) {
          (p.value = e.description), f.classList.remove('rt-autocomplete--open'), t.predictionClickHandler(e);
        },
        x = (function () {
          var e,
            r =
              ((e = i().mark(function e(r) {
                var n, o, a;
                return i().wrap(function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        return (e.next = 2), t.searchHandler(r);
                      case 2:
                        if (
                          ((u = (u = e.sent).slice(0, 5)),
                          f.classList.remove('rt-autocomplete--open'),
                          (g.innerHTML = ''),
                          0 !== p.value.trim().length)
                        ) {
                          e.next = 8;
                          break;
                        }
                        return e.abrupt('return');
                      case 8:
                        if ((f.classList.add('rt-autocomplete--open'), 0 !== u.length)) {
                          e.next = 16;
                          break;
                        }
                        return (
                          (n = document.createElement('li')).classList.add(
                            'rt-prediction',
                            'rt-prediction--zero-results',
                          ),
                          (n.textContent = t.zeroResultsMessage),
                          g.appendChild(n),
                          t.searchIcon && (y.disabled = !0),
                          e.abrupt('return')
                        );
                      case 16:
                        (o = i().mark(function e(r) {
                          var n;
                          return i().wrap(function (e) {
                            for (;;)
                              switch ((e.prev = e.next)) {
                                case 0:
                                  (n = document.createElement('li')).classList.add('rt-prediction'),
                                    0 === r &&
                                      ((s = 0),
                                      n.classList.add('rt-prediction--active'),
                                      t.searchIcon && (y.disabled = !1)),
                                    (n.textContent = u[r].description),
                                    (n.onmouseover = function () {
                                      n.classList.add('rt-prediction--active');
                                    }),
                                    (n.onmouseleave = function () {
                                      n.classList.remove('rt-prediction--active');
                                    }),
                                    (n.onclick = function () {
                                      return w(u[r]);
                                    }),
                                    g.appendChild(n);
                                case 8:
                                case 'end':
                                  return e.stop();
                              }
                          }, e);
                        })),
                          (a = 0);
                      case 18:
                        if (!(a < u.length)) {
                          e.next = 23;
                          break;
                        }
                        return e.delegateYield(o(a), 't0', 20);
                      case 20:
                        ++a, (e.next = 18);
                        break;
                      case 23:
                      case 'end':
                        return e.stop();
                    }
                }, e);
              })),
              function () {
                var t = this,
                  r = arguments;
                return new Promise(function (n, o) {
                  var i = e.apply(t, r);
                  function c(t) {
                    a(i, n, o, c, u, 'next', t);
                  }
                  function u(t) {
                    a(i, n, o, c, u, 'throw', t);
                  }
                  c(void 0);
                });
              });
          return function (t) {
            return r.apply(this, arguments);
          };
        })();
      if (t.searchIcon) {
        var E = document.createElement('img');
        switch (
          ((E.src = t.searchIcon.path), (E.alt = 'search icon'), (E.ariaHidden = 'true'), t.searchIcon.position)
        ) {
          case 'left':
            y.classList.add('rt-icon', 'rt-icon--left');
            break;
          case 'right':
            y.classList.add('rt-icon', 'rt-icon--right');
        }
        (y.disabled = !0),
          y.addEventListener('click', function () {
            var t;
            return w(u[null !== (t = s) && void 0 !== t ? t : 0]);
          }),
          y.appendChild(E),
          h.appendChild(y);
      }
      if (t.clearIcon) {
        var L = document.createElement('img');
        switch (((L.src = t.clearIcon.path), t.clearIcon.position)) {
          case 'left':
            m.classList.add('rt-icon', 'rt-clear-icon', 'rt-icon--left');
            break;
          case 'right':
            m.classList.add('rt-icon', 'rt-clear-icon', 'rt-icon--right');
        }
        m.addEventListener('click', function () {
          b();
        }),
          m.appendChild(L),
          h.appendChild(m);
      }
      return (
        document.addEventListener('click', function (t) {
          f.contains(t.target) || f.classList.remove('rt-autocomplete--open');
        }),
        p.addEventListener('click', function (t) {
          t.target.value.trim().length > 0 && f.classList.add('rt-autocomplete--open');
        }),
        (p.onkeydown = function (t) {
          if (0 !== u.length && null !== s) {
            var e = s;
            if ('Enter' === t.key) {
              var r = e ? u[e] : u[0];
              return w(r);
            }
            'ArrowUp' === t.key && (void 0 === e || 0 === e ? (e = u.length - 1) : (e -= 1), (s = e)),
              'ArrowDown' === t.key && (void 0 === e || e === u.length - 1 ? (e = 0) : (e += 1), (s = e));
            for (var n = 0; n < g.children.length; ++n)
              g.children[n].classList.remove('rt-prediction--active'),
                n === s && g.children[n].classList.add('rt-prediction--active');
          }
        }),
        (p.oninput = function (e) {
          var r = e.target.value;
          t.clearIcon && (r.length > 0 ? m.classList.add('rt-icon--visible') : m.classList.remove('rt-icon--visible')),
            t.searchIcon && (r.length > 0 ? (y.disabled = !1) : (y.disabled = !0));
          var n = r.trim();
          if ('' === n) return b();
          n.length < 3 || l(x, r);
        }),
        [b]
      );
    }
    function u(t) {
      return '[SCROLL-TOP-BUTTON] '.concat(t);
    }
    function s(t) {
      var r, n, o;
      if ('string' == typeof t.anchorEl) {
        var i = document.getElementById(t.anchorEl);
        if (!i) throw new Error(u("(prop=anchorId) cannot find DOM element with id '".concat(t.anchorEl, "'")));
        n = i;
      } else n = t.anchorEl;
      if ('string' == typeof t.scrollingEl) {
        var a = document.getElementById(t.scrollingEl);
        if (!a) throw new Error(u("(prop=scrollingElId) cannot find DOM element with id '".concat(t.scrollingEl, "'")));
        o = a;
      } else o = t.scrollingEl;
      var c = (0, e.uP)()(100),
        s = document.createElement('div');
      (s.id = null !== (r = t.id) && void 0 !== r ? r : ''), s.classList.add('rt-back-to-top');
      var l = function () {
        return c(function () {
          0 === o.scrollTop
            ? s.classList.remove('rt-back-to-top--visible')
            : s.classList.add('rt-back-to-top--visible');
        });
      };
      return (
        o.addEventListener('scroll', l),
        s.addEventListener('click', function () {
          o.scroll({ top: 0, behavior: 'smooth' });
        }),
        n.appendChild(s),
        [
          function (t) {
            var e;
            if ('string' == typeof t) {
              var r = document.getElementById(t);
              if (!r) throw new Error(u("cannot update scrolling element: ID '".concat(t, "' not found in DOM")));
              e = r;
            } else e = t;
            s.classList.remove('rt-back-to-top--visible'), o.removeEventListener('scroll', l), ((o = e).onscroll = l);
          },
        ]
      );
    }
    var l = r(561);
    function d(t) {
      var e, r;
      if ('string' == typeof t.anchor) {
        if (!(r = document.getElementById(t.anchor)))
          throw new Error("(prop=anchorId) cannot find DOM node with ID: '".concat(t.anchor, "'"));
      } else r = t.anchor;
      var n = r,
        o = document.createElement('div');
      o.classList.add('rt-sidebar'),
        'left' === t.position ? o.classList.add('rt-sidebar--left') : o.classList.add('rt-sidebar--right');
      var i = document.createElement('div');
      function a(t) {
        i.replaceChildren((0, l.Y)(l.FK, { children: t }));
      }
      return (
        i.classList.add('rt-sidebar__content'),
        o.appendChild(i),
        o.addEventListener('click', function (t) {
          i.contains(t.target) ||
            document.querySelectorAll('.rt-sidebar').forEach(function (t) {
              return t.classList.remove('rt-sidebar--visible');
            });
        }),
        a(null !== (e = t.content) && void 0 !== e ? e : (0, l.Y)(l.FK, {})),
        n.appendChild(o),
        [
          function (t) {
            t ? o.classList.add('rt-sidebar--visible') : o.classList.remove('rt-sidebar--visible');
          },
          a,
        ]
      );
    }
    function f(t) {
      var e, r, n;
      if ('string' == typeof t.anchor) {
        if (!(r = document.getElementById(t.anchor)))
          throw new Error(
            ((n = "(prop=anchorId) cannot find DOM node with ID: '".concat(t.anchor, "'")), '[SELECT] '.concat(n)),
          );
      } else r = t.anchor;
      var o = r,
        i = document.createElement('div');
      i.classList.add('rt-select', 'rt-select--down'),
        (i.tabIndex = 0),
        (i.ariaLabel = 'search'),
        t.id && (i.id = t.id);
      var a = document.createElement('div');
      a.classList.add('rt-select__selected-text');
      var c = document.createElement('ul');
      c.classList.add('rt-select__option-list');
      var u = function (e) {
          var r = document.createElement('li');
          return (
            r.classList.add('rt-select__option-list__option'),
            r.setAttribute('option_value', e.value),
            (r.innerHTML = e.html),
            (r.onclick = function () {
              d(e.html), t.handleOptionClick && t.handleOptionClick(e);
            }),
            r
          );
        },
        s = !1,
        l = null !== (e = t.placeholder) && void 0 !== e ? e : '';
      a.innerHTML = l;
      var d = function (t) {
          (l = t), (a.innerHTML = l);
        },
        f = function (e) {
          if (((c.innerHTML = ''), t.placeholder)) {
            var r = u({ value: t.placeholder, html: t.placeholder });
            c.appendChild(r);
          }
          for (var n = 0; n < e.length; ++n) {
            0 !== n || t.placeholder || d(e[n].html);
            var o = u(e[n]);
            c.appendChild(o);
          }
        };
      return (
        document.addEventListener('click', function (t) {
          i.contains(t.target) || ((s = !1), i.classList.remove('rt-select--opened'));
        }),
        (i.onclick = function () {
          s ? i.classList.remove('rt-select--opened') : i.classList.add('rt-select--opened'), (s = !s);
        }),
        i.appendChild(a),
        i.appendChild(c),
        o.appendChild(i),
        t.options && f(t.options),
        [f, d, i]
      );
    }
    var h = 'rt-toast-container--bottom-left',
      p = 'rt-toast-container--bottom-right',
      v = 'rt-toast-container--top-left',
      y = 'rt-toast-container--top-right';
    function m(t) {
      var e, r, n;
      if ('string' == typeof t.anchor) {
        if (!(r = document.getElementById(t.anchor)))
          throw new Error(
            ((n = "(prop=anchorId) cannot find DOM node with id: '".concat(t.anchor, "'")),
            '[TOAST-MESSAGE] '.concat(n)),
          );
      } else r = t.anchor;
      var o,
        i = r,
        a = new CustomEvent('toastmessage', { detail: { message: '' } }),
        c = document.createElement('div');
      c.classList.add('rt-toast-container');
      var u = document.createElement('p');
      u.classList.add('rt-toast-container__message');
      var s = document.createElement('div');
      s.classList.add('rt-toast-container__progress-bar');
      var l = function (t) {
        var e, r;
        switch (o) {
          case 'bottom-left':
            e = h;
            break;
          case 'bottom-right':
            e = p;
            break;
          case 'top-left':
            e = v;
            break;
          default:
            e = y;
        }
        switch ((c.classList.remove(e), t)) {
          case 'bottom-left':
            r = h;
            break;
          case 'bottom-right':
            r = p;
            break;
          case 'top-left':
            r = v;
            break;
          default:
            r = y;
        }
        c.classList.add(r), (o = t);
      };
      return (
        c.addEventListener('toastmessage', function (t) {
          var e = t.detail.message;
          console.log('toast message: ', e), (u.textContent = e), c.classList.add('rt-toast-container--animated');
        }),
        c.addEventListener('click', function () {
          return c.classList.add('rt-toast-container--clicked');
        }),
        c.addEventListener('animationend', function () {
          c.classList.remove('rt-toast-container--animated'), c.classList.remove('rt-toast-container--clicked');
        }),
        c.appendChild(u),
        c.appendChild(s),
        i.appendChild(c),
        document
          .querySelector('.rt-toast-container')
          .style.setProperty(
            '--animation-duration-toast',
            ''.concat(null !== (e = t.autoClose) && void 0 !== e ? e : 2e3, 'ms'),
          ),
        l(t.position),
        [
          function (t) {
            (a.detail.message = t), c.dispatchEvent(a);
          },
          l,
        ]
      );
    }
    var g = 10,
      b = 5;
    function w(t) {
      var e,
        r,
        n = t.rows,
        o = t.layout,
        i = {
          rows: { total: n, visible: [] },
          headers: [],
          layout: {
            rowsPerPage: null !== (e = null == o ? void 0 : o.rowsPerPage) && void 0 !== e ? e : g,
            pagination: {
              current: 0,
              visible: null !== (r = null == o ? void 0 : o.visiblePages) && void 0 !== r ? r : b,
              total: 0,
              pages: [],
            },
          },
        };
      return x(i), E(i), L(i), O(i), i;
    }
    function x(t) {
      t.headers = t.rows.total.length > 0 ? Object.keys(t.rows.total[0]) : [];
    }
    function E(t) {
      t.layout.pagination.total = Math.ceil(t.rows.total.length / t.layout.rowsPerPage);
    }
    function L(t) {
      for (
        var e = t.layout.pagination.current * t.layout.rowsPerPage,
          r =
            t.rows.total.length - e >= t.layout.rowsPerPage
              ? t.layout.rowsPerPage
              : t.rows.total.length % t.layout.rowsPerPage,
          n = new Array(r),
          o = 0;
        o < n.length;
        ++o
      )
        n[o] = t.rows.total[o + e];
      t.rows.visible = n;
    }
    function O(t) {
      var e,
        r,
        n,
        o,
        i = t.layout.pagination,
        a = i.total,
        c = i.visible,
        u = i.current,
        s = (c > a ? a : c) / 2;
      s % 2 == 0 ? ((e = s - 1), (r = s)) : (r = e = Math.floor(s)),
        u + r >= a
          ? ((o = a - 1), (n = (n = a - c) < 0 ? 0 : n))
          : u - e < 0
          ? (o = (n = 0) + (c > a ? a : c) - 1)
          : ((n = u - e), (o = u + r)),
        (t.layout.pagination.pages = (function (t, e) {
          return Array.from({ length: e + 1 - t }, function (e, r) {
            return t + r;
          });
        })(n, o));
    }
    function S(t, e) {
      (t.layout.pagination.current = 0), (t.rows.total = e), E(t), x(t), L(t);
    }
    function _(t, e) {
      (t.layout.rowsPerPage = e), (t.layout.pagination.current = 0), E(t), O(t), L(t);
    }
    function P(t, e) {
      e < 0 || e > t.layout.pagination.total - 1 || ((t.layout.pagination.current = e), O(t), L(t));
    }
    function A(t) {
      var e,
        r = t.anchor,
        n = t.content,
        o = t.id,
        i = t.title,
        a = { expanded: !!t.isOpen };
      if ('string' == typeof r) {
        if (!(e = document.getElementById(r)))
          throw new Error("[ACCORDION] (prop=anchorId) cannot find DOM node with ID: '".concat(t.anchor, "'"));
      } else e = r;
      var c = e,
        u = document.createElement('div');
      (u.className = 'rt-accordion'), (u.id = o);
      var s = document.createElement('button');
      (s.type = 'button'),
        s.setAttribute('aria-expanded', 'false'),
        (s.className = 'rt-accordion-trigger'),
        s.setAttribute('aria-controls', 'rt_accordion_panel'),
        (s.id = 'rt_accordion_trigger'),
        (s.onclick = function () {
          s.setAttribute('aria-expanded', a.expanded ? 'false' : 'true'),
            d.toggleAttribute('hidden'),
            (a.expanded = !a.expanded);
        });
      var l = document.createElement('span');
      (l.className = 'rt-accordion-title'), l.appendChild(i);
      var d = document.createElement('div');
      (d.className = 'rt-accordion-panel'),
        (d.id = 'rt_accordion_panel'),
        d.setAttribute('aria-labelledby', 'rt_accordion_trigger'),
        d.setAttribute('hidden', ''),
        d.appendChild(n),
        s.appendChild(l),
        u.appendChild(s),
        u.appendChild(d),
        c.appendChild(u);
    }
    function k(t) {
      return (
        (k =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t;
              }),
        k(t)
      );
    }
    function I() {
      I = function () {
        return e;
      };
      var t,
        e = {},
        r = Object.prototype,
        n = r.hasOwnProperty,
        o =
          Object.defineProperty ||
          function (t, e, r) {
            t[e] = r.value;
          },
        i = 'function' == typeof Symbol ? Symbol : {},
        a = i.iterator || '@@iterator',
        c = i.asyncIterator || '@@asyncIterator',
        u = i.toStringTag || '@@toStringTag';
      function s(t, e, r) {
        return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
      }
      try {
        s({}, '');
      } catch (t) {
        s = function (t, e, r) {
          return (t[e] = r);
        };
      }
      function l(t, e, r, n) {
        var i = e && e.prototype instanceof m ? e : m,
          a = Object.create(i.prototype),
          c = new T(n || []);
        return o(a, '_invoke', { value: _(t, r, c) }), a;
      }
      function d(t, e, r) {
        try {
          return { type: 'normal', arg: t.call(e, r) };
        } catch (t) {
          return { type: 'throw', arg: t };
        }
      }
      e.wrap = l;
      var f = 'suspendedStart',
        h = 'suspendedYield',
        p = 'executing',
        v = 'completed',
        y = {};
      function m() {}
      function g() {}
      function b() {}
      var w = {};
      s(w, a, function () {
        return this;
      });
      var x = Object.getPrototypeOf,
        E = x && x(x(C([])));
      E && E !== r && n.call(E, a) && (w = E);
      var L = (b.prototype = m.prototype = Object.create(w));
      function O(t) {
        ['next', 'throw', 'return'].forEach(function (e) {
          s(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function S(t, e) {
        function r(o, i, a, c) {
          var u = d(t[o], t, i);
          if ('throw' !== u.type) {
            var s = u.arg,
              l = s.value;
            return l && 'object' == k(l) && n.call(l, '__await')
              ? e.resolve(l.__await).then(
                  function (t) {
                    r('next', t, a, c);
                  },
                  function (t) {
                    r('throw', t, a, c);
                  },
                )
              : e.resolve(l).then(
                  function (t) {
                    (s.value = t), a(s);
                  },
                  function (t) {
                    return r('throw', t, a, c);
                  },
                );
          }
          c(u.arg);
        }
        var i;
        o(this, '_invoke', {
          value: function (t, n) {
            function o() {
              return new e(function (e, o) {
                r(t, n, e, o);
              });
            }
            return (i = i ? i.then(o, o) : o());
          },
        });
      }
      function _(e, r, n) {
        var o = f;
        return function (i, a) {
          if (o === p) throw Error('Generator is already running');
          if (o === v) {
            if ('throw' === i) throw a;
            return { value: t, done: !0 };
          }
          for (n.method = i, n.arg = a; ; ) {
            var c = n.delegate;
            if (c) {
              var u = P(c, n);
              if (u) {
                if (u === y) continue;
                return u;
              }
            }
            if ('next' === n.method) n.sent = n._sent = n.arg;
            else if ('throw' === n.method) {
              if (o === f) throw ((o = v), n.arg);
              n.dispatchException(n.arg);
            } else 'return' === n.method && n.abrupt('return', n.arg);
            o = p;
            var s = d(e, r, n);
            if ('normal' === s.type) {
              if (((o = n.done ? v : h), s.arg === y)) continue;
              return { value: s.arg, done: n.done };
            }
            'throw' === s.type && ((o = v), (n.method = 'throw'), (n.arg = s.arg));
          }
        };
      }
      function P(e, r) {
        var n = r.method,
          o = e.iterator[n];
        if (o === t)
          return (
            (r.delegate = null),
            ('throw' === n &&
              e.iterator.return &&
              ((r.method = 'return'), (r.arg = t), P(e, r), 'throw' === r.method)) ||
              ('return' !== n &&
                ((r.method = 'throw'), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
            y
          );
        var i = d(o, e.iterator, r.arg);
        if ('throw' === i.type) return (r.method = 'throw'), (r.arg = i.arg), (r.delegate = null), y;
        var a = i.arg;
        return a
          ? a.done
            ? ((r[e.resultName] = a.value),
              (r.next = e.nextLoc),
              'return' !== r.method && ((r.method = 'next'), (r.arg = t)),
              (r.delegate = null),
              y)
            : a
          : ((r.method = 'throw'), (r.arg = new TypeError('iterator result is not an object')), (r.delegate = null), y);
      }
      function A(t) {
        var e = { tryLoc: t[0] };
        1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
      }
      function j(t) {
        var e = t.completion || {};
        (e.type = 'normal'), delete e.arg, (t.completion = e);
      }
      function T(t) {
        (this.tryEntries = [{ tryLoc: 'root' }]), t.forEach(A, this), this.reset(!0);
      }
      function C(e) {
        if (e || '' === e) {
          var r = e[a];
          if (r) return r.call(e);
          if ('function' == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function r() {
                for (; ++o < e.length; ) if (n.call(e, o)) return (r.value = e[o]), (r.done = !1), r;
                return (r.value = t), (r.done = !0), r;
              };
            return (i.next = i);
          }
        }
        throw new TypeError(k(e) + ' is not iterable');
      }
      return (
        (g.prototype = b),
        o(L, 'constructor', { value: b, configurable: !0 }),
        o(b, 'constructor', { value: g, configurable: !0 }),
        (g.displayName = s(b, u, 'GeneratorFunction')),
        (e.isGeneratorFunction = function (t) {
          var e = 'function' == typeof t && t.constructor;
          return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name));
        }),
        (e.mark = function (t) {
          return (
            Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : ((t.__proto__ = b), s(t, u, 'GeneratorFunction')),
            (t.prototype = Object.create(L)),
            t
          );
        }),
        (e.awrap = function (t) {
          return { __await: t };
        }),
        O(S.prototype),
        s(S.prototype, c, function () {
          return this;
        }),
        (e.AsyncIterator = S),
        (e.async = function (t, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new S(l(t, r, n, o), i);
          return e.isGeneratorFunction(r)
            ? a
            : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
        }),
        O(L),
        s(L, u, 'Generator'),
        s(L, a, function () {
          return this;
        }),
        s(L, 'toString', function () {
          return '[object Generator]';
        }),
        (e.keys = function (t) {
          var e = Object(t),
            r = [];
          for (var n in e) r.push(n);
          return (
            r.reverse(),
            function t() {
              for (; r.length; ) {
                var n = r.pop();
                if (n in e) return (t.value = n), (t.done = !1), t;
              }
              return (t.done = !0), t;
            }
          );
        }),
        (e.values = C),
        (T.prototype = {
          constructor: T,
          reset: function (e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = t),
              (this.done = !1),
              (this.delegate = null),
              (this.method = 'next'),
              (this.arg = t),
              this.tryEntries.forEach(j),
              !e)
            )
              for (var r in this) 't' === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          },
          stop: function () {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ('throw' === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function (e) {
            if (this.done) throw e;
            var r = this;
            function o(n, o) {
              return (c.type = 'throw'), (c.arg = e), (r.next = n), o && ((r.method = 'next'), (r.arg = t)), !!o;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var a = this.tryEntries[i],
                c = a.completion;
              if ('root' === a.tryLoc) return o('end');
              if (a.tryLoc <= this.prev) {
                var u = n.call(a, 'catchLoc'),
                  s = n.call(a, 'finallyLoc');
                if (u && s) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                } else if (u) {
                  if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                } else {
                  if (!s) throw Error('try statement without catch or finally');
                  if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                }
              }
            }
          },
          abrupt: function (t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return (
              (a.type = t), (a.arg = e), i ? ((this.method = 'next'), (this.next = i.finallyLoc), y) : this.complete(a)
            );
          },
          complete: function (t, e) {
            if ('throw' === t.type) throw t.arg;
            return (
              'break' === t.type || 'continue' === t.type
                ? (this.next = t.arg)
                : 'return' === t.type
                ? ((this.rval = this.arg = t.arg), (this.method = 'return'), (this.next = 'end'))
                : 'normal' === t.type && e && (this.next = e),
              y
            );
          },
          finish: function (t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), j(r), y;
            }
          },
          catch: function (t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.tryLoc === t) {
                var n = r.completion;
                if ('throw' === n.type) {
                  var o = n.arg;
                  j(r);
                }
                return o;
              }
            }
            throw Error('illegal catch attempt');
          },
          delegateYield: function (e, r, n) {
            return (
              (this.delegate = { iterator: C(e), resultName: r, nextLoc: n }),
              'next' === this.method && (this.arg = t),
              y
            );
          },
        }),
        e
      );
    }
    function j(t, e, r, n, o, i, a) {
      try {
        var c = t[i](a),
          u = c.value;
      } catch (t) {
        return void r(t);
      }
      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }
    function T(t) {
      return function () {
        var e = this,
          r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);
          function a(t) {
            j(i, n, o, a, c, 'next', t);
          }
          function c(t) {
            j(i, n, o, a, c, 'throw', t);
          }
          a(void 0);
        });
      };
    }
    function C(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function D(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          r.push.apply(r, n);
      }
      return r;
    }
    function N(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          'value' in n && (n.writable = !0),
          Object.defineProperty(t, R(n.key), n);
      }
    }
    function G(t, e, r) {
      return (
        (e = R(e)) in t
          ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 })
          : (t[e] = r),
        t
      );
    }
    function R(t) {
      var e = (function (t, e) {
        if ('object' != k(t) || !t) return t;
        var r = t[Symbol.toPrimitive];
        if (void 0 !== r) {
          var n = r.call(t, 'string');
          if ('object' != k(n)) return n;
          throw new TypeError('@@toPrimitive must return a primitive value.');
        }
        return String(t);
      })(t);
      return 'symbol' == k(e) ? e : e + '';
    }
    var M = (function () {
      return (
        (t = function t(r) {
          var n, o;
          if (
            ((function (t, e) {
              if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
            })(this, t),
            G(this, 'inputDebounce', (0, e.uP)()(300)),
            'string' == typeof r.anchor)
          ) {
            if (!(o = document.getElementById(r.anchor)))
              throw new Error('Cannot find DOM element with id: "'.concat(r.anchor, '"'));
          } else o = r.anchor;
          (this.id = r.id),
            (this.translations = r.translations),
            (this.state = {
              isExpanded: !1,
              predictions: [],
              activePrediction: 0,
              maxPredictions: null !== (n = r.maxPredictions) && void 0 !== n ? n : 5,
            }),
            (this.cb = (function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2
                  ? D(Object(r), !0).forEach(function (e) {
                      G(t, e, r[e]);
                    })
                  : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                  : D(Object(r)).forEach(function (e) {
                      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
              }
              return t;
            })({}, r.handlers)),
            (this.autocompleteContainerEl = this.renderInitialUI(r)),
            (this.inputEl = this.autocompleteContainerEl.querySelector('#rt_autocomplete_'.concat(this.id))),
            (this.predictionsEl = this.autocompleteContainerEl.querySelector('#rt_predictions_'.concat(this.id))),
            o.appendChild(this.autocompleteContainerEl),
            this.autocompleteContainerEl.addEventListener('keydown', this.handleKeydown.bind(this)),
            this.autocompleteContainerEl.addEventListener('keyup', this.handleKeyup.bind(this));
        }),
        (r = [
          {
            key: 'updateUI',
            value: function () {
              var t,
                e,
                r = this;
              this.state.isExpanded
                ? (this.autocompleteContainerEl.classList.add('open'),
                  this.inputEl.setAttribute('aria-expanded', 'true'),
                  (t = this.predictionsEl).replaceChildren.apply(
                    t,
                    (function (t) {
                      if (Array.isArray(t)) return C(t);
                    })(
                      (e = this.state.predictions.map(function (t, e) {
                        var n = e === r.state.activePrediction;
                        return (
                          n &&
                            r.inputEl.setAttribute(
                              'aria-activedescendant',
                              'rt_autocomplete_prediction_'.concat(r.id, '_').concat(e),
                            ),
                          (0, l.Y)('div', {
                            role: 'option',
                            id: 'rt_autocomplete_prediction_'.concat(r.id, '_').concat(e),
                            class: 'autocomplete-option '.concat(n ? 'option-current' : ''),
                            'aria-selected': n ? 'true' : 'false',
                            onclick: function () {
                              if (t.description !== r.translations.zeroResultsMessage) {
                                r.state.isExpanded = !1;
                                var e = r.state.predictions[r.state.activePrediction];
                                (r.inputEl.value = e.description), r.cb.predictionsSelection(e), r.updateUI();
                              }
                            },
                            children: t.description,
                          })
                        );
                      })),
                    ) ||
                      (function (t) {
                        if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                          return Array.from(t);
                      })(e) ||
                      (function (t, e) {
                        if (t) {
                          if ('string' == typeof t) return C(t, e);
                          var r = Object.prototype.toString.call(t).slice(8, -1);
                          return (
                            'Object' === r && t.constructor && (r = t.constructor.name),
                            'Map' === r || 'Set' === r
                              ? Array.from(t)
                              : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? C(t, e)
                              : void 0
                          );
                        }
                      })(e) ||
                      (function () {
                        throw new TypeError(
                          'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                        );
                      })(),
                  ))
                : (this.autocompleteContainerEl.classList.remove('open'),
                  this.inputEl.setAttribute('aria-expanded', 'false'),
                  this.inputEl.removeAttribute('aria-activedescendant'));
            },
          },
          {
            key: 'handleKeydown',
            value: function (t) {
              9 === t.keyCode &&
                document.activeElement === this.inputEl &&
                ((this.state.isExpanded = !1), this.updateUI());
            },
          },
          {
            key: 'handleKeyup',
            value: function (t) {
              var e = this;
              if (document.activeElement === this.inputEl)
                switch (t.keyCode) {
                  case 9:
                    break;
                  case 13:
                    if (this.state.isExpanded) {
                      var r = this.state.predictions[this.state.activePrediction];
                      r.description != this.translations.zeroResultsMessage &&
                        ((this.state.isExpanded = !1),
                        (this.inputEl.value = r.description),
                        this.cb.predictionsSelection(r),
                        this.updateUI());
                    }
                    break;
                  case 27:
                    (this.state.isExpanded = !1), this.updateUI();
                    break;
                  case 35:
                    (this.state.isExpanded = !0),
                      (this.state.activePrediction = this.state.predictions.length - 1),
                      this.updateUI();
                    break;
                  case 36:
                    (this.state.isExpanded = !0), (this.state.activePrediction = 0), this.updateUI();
                    break;
                  case 40:
                    this.state.isExpanded
                      ? this.state.activePrediction < this.state.predictions.length - 1 && ++this.state.activePrediction
                      : (this.state.isExpanded = !0),
                      this.updateUI();
                    break;
                  case 38:
                    this.state.isExpanded &&
                      this.state.activePrediction > 0 &&
                      (--this.state.activePrediction, this.updateUI());
                    break;
                  default:
                    var n = this.inputEl.value.trim();
                    if (n.length < 3) return;
                    this.inputDebounce(
                      T(
                        I().mark(function t() {
                          var r;
                          return I().wrap(function (t) {
                            for (;;)
                              switch ((t.prev = t.next)) {
                                case 0:
                                  return (t.next = 2), e.cb.predictionsSearch(n);
                                case 2:
                                  (r = t.sent),
                                    (e.state.isExpanded = !0),
                                    (e.state.activePrediction = 0),
                                    r.length > 0
                                      ? (e.state.predictions = r.slice(0, e.state.maxPredictions))
                                      : (e.state.predictions = [{ description: e.translations.zeroResultsMessage }]),
                                    e.updateUI();
                                case 7:
                                case 'end':
                                  return t.stop();
                              }
                          }, t);
                        }),
                      ),
                    );
                }
            },
          },
          {
            key: 'renderInitialUI',
            value: function (t) {
              var e = this,
                r = t.translations,
                n = t.clearIcon,
                o = t.selectIcon;
              return (0, l.FD)('div', {
                id: 'rt_autocomplete_'.concat(this.id, '_container'),
                class: 'autocomplete',
                children: [
                  (0, l.Y)('label', {
                    id: 'rt_autocomplete_'.concat(this.id, '_label'),
                    for: 'rt_autocomplete_'.concat(this.id),
                    class: 'autocomplete-label',
                    children: r.inputLabel,
                  }),
                  (0, l.FD)('div', {
                    class: 'autocomplete-input-container',
                    children: [
                      (0, l.Y)('input', {
                        'aria-controls': 'rt_predictions_'.concat(this.id),
                        'aria-expanded': 'false',
                        'aria-haspopup': 'listbox',
                        'aria-labelledby': 'rt_autocomplete_'.concat(this.id, '_label'),
                        id: 'rt_autocomplete_'.concat(this.id),
                        class: 'autocomplete-input',
                        role: 'searchbox',
                        tabindex: '0',
                        'aria-activedescendant': '',
                        placeholder: r.inputPlaceholder,
                      }),
                      n &&
                        (0, l.Y)('button', {
                          id: 'rt_autocomplete_'.concat(this.id, '_clear'),
                          class: 'autocomplete-icon autocomplete-icon--reset',
                          'aria-label': n.ariaLabel,
                          onclick: this.resetAutocomplete,
                          children: (0, l.Y)('img', { src: n.url, alt: 'reset icon', 'aria-hidden': 'true' }),
                        }),
                      o &&
                        (0, l.Y)('button', {
                          id: 'rt_autocomplete_'.concat(this.id, '_search'),
                          class: 'autocomplete-icon autocomplete-icon--search',
                          'aria-label': o.ariaLabel,
                          onclick: function () {
                            if (
                              e.state.predictions.length > 0 &&
                              e.state.predictions[0].description !== e.translations.zeroResultsMessage
                            ) {
                              e.state.isExpanded = !1;
                              var t = e.state.predictions[e.state.activePrediction];
                              (e.inputEl.value = t.description), e.cb.predictionsSelection(t), e.updateUI();
                            }
                          },
                          children: (0, l.Y)('img', { src: o.url, alt: 'search icon', 'aria-hidden': 'true' }),
                        }),
                    ],
                  }),
                  (0, l.Y)('div', {
                    id: 'rt_predictions_'.concat(this.id),
                    class: 'autocomplete-menu',
                    role: 'listbox',
                    'aria-labelledby': 'rt_autocomplete_'.concat(this.id, '_label'),
                    tabindex: '-1',
                  }),
                ],
              });
            },
          },
          {
            key: 'resetAutocomplete',
            value: function () {
              (this.inputEl.value = ''),
                (this.state.predictions = []),
                (this.state.activePrediction = 0),
                (this.state.isExpanded = !1),
                this.updateUI();
            },
          },
        ]) && N(t.prototype, r),
        Object.defineProperty(t, 'prototype', { writable: !1 }),
        t
      );
      var t, r;
    })();
    function F(t) {
      return (
        (function (t) {
          if (Array.isArray(t)) return U(t);
        })(t) ||
        (function (t) {
          if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
            return Array.from(t);
        })(t) ||
        (function (t, e) {
          if (t) {
            if ('string' == typeof t) return U(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return (
              'Object' === r && t.constructor && (r = t.constructor.name),
              'Map' === r || 'Set' === r
                ? Array.from(t)
                : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                ? U(t, e)
                : void 0
            );
          }
        })(t) ||
        (function () {
          throw new TypeError(
            'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        })()
      );
    }
    function U(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    function Y(t) {
      var e,
        r,
        n = { expanded: !1, activeDescendantIndex: 0, selectedOptionIndex: 0, search: { letter: '', optionIndex: 0 } },
        o = t.anchor;
      if ((t.id, 'string' == typeof o)) {
        if (!(r = document.getElementById(o)))
          throw new Error("[SELECT] (prop=anchorId) cannot find DOM node with ID: '".concat(o, "'"));
      } else r = o;
      var i = r;
      (i.innerHTML = ''),
        i.appendChild(
          (0, l.Y)(l.FK, {
            children: (0, l.FD)('div', {
              id: ''.concat(t.id, '-select'),
              class: 'combo',
              onclick: function (e) {
                var r;
                e.stopPropagation(),
                  (n.expanded = !n.expanded),
                  (n.activeDescendantIndex =
                    null !== (r = n.activeDescendantIndex) && void 0 !== r ? r : ''.concat(t.id, '-combo1-0')),
                  d();
              },
              children: [
                t.title &&
                  (0, l.Y)('div', { id: ''.concat(t.id, '-combo1-label'), class: 'combo-label', children: t.title }),
                (0, l.FD)('div', {
                  'aria-controls': 'listbox1',
                  'aria-expanded': 'false',
                  'aria-haspopup': 'listbox',
                  'aria-labelledby': ''.concat(t.id, '-combo1-label'),
                  id: ''.concat(t.id, '-combo1'),
                  class: 'combo-input',
                  role: 'combobox',
                  tabIndex: '0',
                  children: [
                    t.placeholder,
                    (0, l.Y)('img', {
                      id: ''.concat(t.id, '_icon'),
                      src: t.chevronIconSrc,
                      alt: 'chevron icon',
                      'aria-hidden': 'true',
                    }),
                  ],
                }),
                (0, l.Y)('div', {
                  class: 'combo-menu',
                  role: 'listbox',
                  id: ''.concat(t.id, '-listbox1'),
                  'aria-labelledby': 'combo1-label',
                  tabIndex: '-1',
                }),
              ],
            }),
          }),
        );
      var a = i.querySelector('#'.concat(t.id, '-select')),
        c = i.querySelector('#'.concat(t.id, '-combo1')),
        u = i.querySelector('#'.concat(t.id, '-listbox1')),
        s = i.querySelector('#'.concat(t.id, '_icon'));
      function d() {
        n.expanded
          ? (a.classList.add('open'),
            c.setAttribute('aria-expanded', 'true'),
            u.replaceChildren.apply(u, F(e.map(h))),
            c.setAttribute('aria-activedescendant', u.children[n.activeDescendantIndex].id),
            u.children[n.activeDescendantIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' }))
          : (a.classList.remove('open'),
            c.setAttribute('aria-expanded', 'false'),
            c.removeAttribute('aria-activedescendant'),
            (c.textContent = e[n.selectedOptionIndex].html),
            c.appendChild(s));
      }
      function f(r) {
        (e = [{ html: t.placeholder, value: t.placeholder }].concat(F(r))),
          (n.activeDescendantIndex = 0),
          (n.selectedOptionIndex = 0),
          (n.expanded = !1),
          (n.search.letter = ''),
          (n.search.optionIndex = 0),
          d();
      }
      function h(e, r) {
        return (0, l.Y)('div', {
          role: 'option',
          id: ''.concat(t.id, '-combo1-').concat(r),
          class: 'combo-option '.concat(n.activeDescendantIndex === r ? 'option-current' : ''),
          'aria-selected': n.selectedOptionIndex === r ? 'true' : 'false',
          'option-value': e.value,
          onmousedown: function (o) {
            o.stopPropagation(),
              (n.activeDescendantIndex = r),
              (n.selectedOptionIndex = r),
              (n.expanded = !1),
              t.handleOptionClick && t.handleOptionClick(e),
              d();
          },
          children: e.html,
        });
      }
      return (
        t.options && f(t.options),
        a.addEventListener('focusout', function () {
          n.expanded && ((n.expanded = !1), (n.selectedOptionIndex = n.activeDescendantIndex), d());
        }),
        (a.onkeydown = function (t) {
          switch (t.code) {
            case 'ArrowDown':
            case 'ArrowUp':
            case 'End':
            case 'Home':
            case 'Space':
              t.preventDefault();
          }
        }),
        (a.onkeyup = function (r) {
          var o;
          n.activeDescendantIndex =
            null !== (o = n.activeDescendantIndex) && void 0 !== o ? o : ''.concat(t.id, '-combo1-0');
          var i = r.code;
          switch (i) {
            case 'Space':
            case 'Enter':
              n.expanded
                ? ((n.selectedOptionIndex = n.activeDescendantIndex),
                  (n.expanded = !1),
                  t.handleOptionClick && t.handleOptionClick(e[n.selectedOptionIndex]))
                : (n.expanded = !0),
                d();
              break;
            case 'Escape':
              n.expanded && ((n.expanded = !1), d());
              break;
            case 'ArrowDown':
              n.expanded && n.activeDescendantIndex < e.length - 1 ? ++n.activeDescendantIndex : (n.expanded = !0), d();
              break;
            case 'ArrowUp':
              n.expanded && n.activeDescendantIndex > 0 ? --n.activeDescendantIndex : (n.expanded = !0), d();
              break;
            case 'Home':
              n.expanded || (n.expanded = !0), (n.activeDescendantIndex = 0), d();
              break;
            case 'End':
              n.expanded || (n.expanded = !0), (n.activeDescendantIndex = e.length - 1), d();
              break;
            default:
              var a = i.split('Key')[1];
              null != a &&
                a.match(/[A-Z]/gm) &&
                (n.expanded || (n.expanded = !0),
                (function (t) {
                  t !== n.search.letter && (n.search.optionIndex = 0);
                  for (var r = [], o = 0; o < e.length; ++o) e[o].html.charAt(0).toUpperCase() === t && r.push(o);
                  if (0 !== r.length) {
                    var i = n.search.optionIndex,
                      a = r[r.length > 1 ? i : 0];
                    (n.activeDescendantIndex = a),
                      (n.search.letter = e[a].html.charAt(0).toLocaleUpperCase()),
                      (n.search.optionIndex = (i + 1) % r.length);
                  }
                })(a),
                d());
          }
        }),
        [f]
      );
    }
    function H(t, e) {
      var r = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
      if (!r) {
        if (
          Array.isArray(t) ||
          (r = (function (t, e) {
            if (t) {
              if ('string' == typeof t) return B(t, e);
              var r = Object.prototype.toString.call(t).slice(8, -1);
              return (
                'Object' === r && t.constructor && (r = t.constructor.name),
                'Map' === r || 'Set' === r
                  ? Array.from(t)
                  : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                  ? B(t, e)
                  : void 0
              );
            }
          })(t)) ||
          (e && t && 'number' == typeof t.length)
        ) {
          r && (t = r);
          var n = 0,
            o = function () {};
          return {
            s: o,
            n: function () {
              return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
            },
            e: function (t) {
              throw t;
            },
            f: o,
          };
        }
        throw new TypeError(
          'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      }
      var i,
        a = !0,
        c = !1;
      return {
        s: function () {
          r = r.call(t);
        },
        n: function () {
          var t = r.next();
          return (a = t.done), t;
        },
        e: function (t) {
          (c = !0), (i = t);
        },
        f: function () {
          try {
            a || null == r.return || r.return();
          } finally {
            if (c) throw i;
          }
        },
      };
    }
    function B(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    var K = { activeDescendant: null, expanded: 'false', search: { letter: '', optionIndex: 0 } };
    function J(t) {
      var e,
        r = t.anchor,
        n = t.id;
      if ('string' == typeof r) {
        if (!(e = document.getElementById(r)))
          throw new Error("[SELECT] (prop=anchorId) cannot find DOM node with ID: '".concat(r, "'"));
      } else e = r;
      var o = e,
        i = document.createElement('div');
      if (
        (i.setAttribute('expanded', 'false'),
        (i.id = n),
        (i.className = 'combo js-select'),
        (i.onclick = function () {
          'false' === K.expanded
            ? ((K.expanded = 'true'),
              K.activeDescendant || (K.activeDescendant = 'combo1-0'),
              i.classList.add('open'),
              c.setAttribute('aria-expanded', 'true'),
              c.setAttribute('aria-activedescendant', K.activeDescendant))
            : (c.removeAttribute('aria-activedescendant'),
              (K.expanded = 'false'),
              i.classList.remove('open'),
              c.setAttribute('aria-expanded', 'false'));
        }),
        t.title)
      ) {
        var a = document.createElement('div');
        (a.id = 'combo1-label'), (a.textContent = t.title), (a.className = 'combo-label'), i.appendChild(a);
      }
      var c = document.createElement('div');
      c.setAttribute('aria-controls', 'listbox1'),
        c.setAttribute('aria-expanded', K.expanded),
        c.setAttribute('aria-haspopup', 'listbox'),
        c.setAttribute('aria-labelledby', 'combo1-label'),
        (c.id = 'combo1'),
        (c.className = 'combo-input'),
        (c.role = 'combobox'),
        (c.tabIndex = 0),
        (c.textContent = t.placeholder);
      var u = document.createElement('img');
      (u.src = t.chevronIconSrc), (u.alt = 'chevron'), u.setAttribute('aria-hidden', 'true'), c.appendChild(u);
      var s = document.createElement('div');
      function l(e) {
        s.innerHTML = '';
        var r = d({ html: t.placeholder, value: t.placeholder });
        r.classList.add('option-current'),
          r.setAttribute('aria-selected', 'true'),
          s.appendChild(r),
          e.forEach(function (t) {
            var e = d(t);
            s.appendChild(e);
          });
      }
      function d(e) {
        var r = document.createElement('div');
        return (
          (r.id = 'combo1-'.concat(s.children.length)),
          (r.innerHTML = e.html),
          (r.role = 'option'),
          (r.className = 'combo-option'),
          r.setAttribute('aria-selected', 'false'),
          r.setAttribute('option_value', e.value),
          (r.onmousedown = function (r) {
            r.stopPropagation();
            var n = r.currentTarget;
            K.activeDescendant = n.id;
            var o,
              i = H(s.children);
            try {
              for (i.s(); !(o = i.n()).done; ) {
                var a = o.value;
                a.setAttribute('aria-selected', 'false'),
                  a.classList.remove('option-current'),
                  K.activeDescendant === a.id &&
                    (a.setAttribute('aria-selected', 'true'),
                    a.classList.add('option-current'),
                    (c.textContent = a.textContent)),
                  c.setAttribute('aria-activedescendant', '');
              }
            } catch (t) {
              i.e(t);
            } finally {
              i.f();
            }
            t.handleOptionClick && t.handleOptionClick(e);
          }),
          r
        );
      }
      return (
        (s.role = 'listbox'),
        (s.id = 'listbox1'),
        (s.className = 'combo-menu'),
        (s.tabIndex = -1),
        s.setAttribute('aria-labelledby', 'combo1-label'),
        i.addEventListener('focusout', function () {
          if ('true' === K.expanded && K.activeDescendant) {
            var t,
              e = H(s.children);
            try {
              for (e.s(); !(t = e.n()).done; ) {
                var r = t.value;
                r.setAttribute('aria-selected', 'false'),
                  K.activeDescendant === r.id &&
                    (r.setAttribute('aria-selected', 'true'), (c.textContent = r.textContent));
              }
            } catch (t) {
              e.e(t);
            } finally {
              e.f();
            }
          }
          c.setAttribute('aria-activedescendant', ''),
            c.setAttribute('aria-expanded', 'false'),
            i.classList.remove('open'),
            (K.expanded = 'false');
        }),
        (i.onkeyup = function (e) {
          var r = e.code;
          switch (r) {
            case 'Enter':
            case 'Space':
              if ('true' === K.expanded) {
                var n,
                  o = H(s.children);
                try {
                  for (o.s(); !(n = o.n()).done; ) {
                    var a = n.value;
                    a.setAttribute('aria-selected', 'false'),
                      K.activeDescendant === a.id &&
                        (a.setAttribute('aria-selected', 'true'),
                        (c.textContent = a.textContent),
                        t.handleOptionClick && t.handleOptionClick({ value: a.getAttribute('option_value') }));
                  }
                } catch (t) {
                  o.e(t);
                } finally {
                  o.f();
                }
                (K.expanded = 'false'),
                  c.setAttribute('aria-activedescendant', ''),
                  c.setAttribute('aria-expanded', 'false'),
                  i.classList.remove('open');
              } else
                K.activeDescendant
                  ? c.setAttribute('aria-activedescendant', K.activeDescendant)
                  : (K.activeDescendant = 'combo1-0'),
                  (K.expanded = 'true'),
                  c.setAttribute('aria-activedescendant', K.activeDescendant),
                  c.setAttribute('aria-expanded', 'true'),
                  i.classList.add('open');
              break;
            case 'Escape':
              'true' === K.expanded &&
                ((K.expanded = 'false'),
                i.classList.remove('open'),
                c.setAttribute('aria-expanded', 'false'),
                c.setAttribute('aria-activedescendant', ''));
              break;
            case 'ArrowDown':
              if ('false' === K.expanded)
                (K.expanded = 'true'),
                  i.classList.add('open'),
                  c.setAttribute('aria-expanded', 'true'),
                  K.activeDescendant || (K.activeDescendant = 'combo1-0');
              else if (K.activeDescendant) {
                var u = +K.activeDescendant.split('-')[1];
                u < s.children.length - 1 && (K.activeDescendant = 'combo1-'.concat(++u));
              }
              var l,
                d = H(s.children);
              try {
                for (d.s(); !(l = d.n()).done; ) {
                  var f = l.value;
                  f.classList.remove('option-current'),
                    f.id === K.activeDescendant &&
                      (c.setAttribute('aria-activedescendant', K.activeDescendant),
                      f.classList.add('option-current'),
                      f.scrollIntoView());
                }
              } catch (t) {
                d.e(t);
              } finally {
                d.f();
              }
              break;
            case 'ArrowUp':
              if ('false' === K.expanded)
                (K.expanded = 'true'), i.classList.add('open'), c.setAttribute('aria-expanded', 'true');
              else if (K.activeDescendant && 'combo1-0' !== K.activeDescendant) {
                var h = +K.activeDescendant.split('-')[1];
                K.activeDescendant = 'combo1-'.concat(--h);
              } else K.activeDescendant = 'combo1-0';
              var p,
                v = H(s.children);
              try {
                for (v.s(); !(p = v.n()).done; ) {
                  var y = p.value;
                  y.classList.remove('option-current'),
                    y.id === K.activeDescendant &&
                      (c.setAttribute('aria-activedescendant', K.activeDescendant),
                      y.classList.add('option-current'),
                      y.scrollIntoView());
                }
              } catch (t) {
                v.e(t);
              } finally {
                v.f();
              }
              break;
            case 'Home':
              'false' === K.expanded &&
                ((K.expanded = 'true'), i.classList.add('open'), c.setAttribute('aria-expanded', 'true')),
                (K.activeDescendant = 'combo1-0');
              var m,
                g = H(s.children);
              try {
                for (g.s(); !(m = g.n()).done; ) {
                  var b = m.value;
                  b.classList.remove('option-current'),
                    b.id === K.activeDescendant &&
                      (c.setAttribute('aria-activedescendant', K.activeDescendant),
                      b.classList.add('option-current'),
                      b.scrollIntoView());
                }
              } catch (t) {
                g.e(t);
              } finally {
                g.f();
              }
              break;
            case 'End':
              'false' === K.expanded &&
                ((K.expanded = 'true'), i.classList.add('open'), c.setAttribute('aria-expanded', 'true')),
                (K.activeDescendant = 'combo1-'.concat(s.children.length - 1));
              var w,
                x = H(s.children);
              try {
                for (x.s(); !(w = x.n()).done; ) {
                  var E = w.value;
                  E.classList.remove('option-current'),
                    E.id === K.activeDescendant &&
                      (c.setAttribute('aria-activedescendant', K.activeDescendant),
                      E.classList.add('option-current'),
                      E.scrollIntoView());
                }
              } catch (t) {
                x.e(t);
              } finally {
                x.f();
              }
              break;
            default:
              var L = r.split('Key')[1];
              null != L &&
                L.match(/[A-Z]/gm) &&
                ('false' === K.expanded &&
                  ((K.expanded = 'true'), i.classList.add('open'), c.setAttribute('aria-expanded', 'true')),
                (function (t) {
                  t !== K.search.letter && (K.search.optionIndex = 0);
                  var e,
                    r = [],
                    n = H(s.children);
                  try {
                    for (n.s(); !(e = n.n()).done; ) {
                      var o,
                        i = e.value;
                      i.classList.remove('option-current'),
                        (null === (o = i.textContent) || void 0 === o ? void 0 : o.charAt(0).toUpperCase()) === t &&
                          r.push(i.id);
                    }
                  } catch (t) {
                    n.e(t);
                  } finally {
                    n.f();
                  }
                  if (0 === r.length)
                    return (
                      document.getElementById(K.activeDescendant).classList.add('option-current'),
                      void (K.search.optionIndex = 0)
                    );
                  var a = K.search.optionIndex,
                    u = document.getElementById(r[r.length > 1 ? a : 0]);
                  (K.search.letter = u.textContent.charAt(0).toLocaleUpperCase()),
                    u.classList.add('option-current'),
                    u.scrollIntoView(),
                    (K.activeDescendant = u.id),
                    c.setAttribute('aria-activedescendant', K.activeDescendant),
                    (K.search.optionIndex = (a + 1) % r.length);
                })(L));
          }
        }),
        t.options && l(t.options),
        i.appendChild(c),
        i.appendChild(s),
        o.appendChild(i),
        [l]
      );
    }
  })(),
    (exports.ARIA_Autocomplete = n.ARIA_Autocomplete),
    (exports.ARIA_createAccordion = n.ARIA_createAccordion),
    (exports.ARIA_createSelect = n.ARIA_createSelect),
    (exports.DEPRECATED__ARIA_createSelect = n.DEPRECATED__ARIA_createSelect),
    (exports.createAccordion = n.createAccordion),
    (exports.createAutocomplete = n.createAutocomplete),
    (exports.createScrollButton = n.createScrollButton),
    (exports.createSelect = n.createSelect),
    (exports.createSidebar = n.createSidebar),
    (exports.createTable = n.createTable),
    (exports.createToastMessagesContainer = n.createToastMessagesContainer),
    (exports.updateCurrentPage = n.updateCurrentPage),
    (exports.updateRows = n.updateRows),
    (exports.updateRowsPerPage = n.updateRowsPerPage),
    Object.defineProperty(exports, '__esModule', { value: !0 });
})();
//# sourceMappingURL=index.js.map
